(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3583,1539],{

/***/ 65169:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer-career-report-2024",
      function () {
        return __webpack_require__(2940);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 45426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jd": function() { return /* binding */ StyledRadioButtonIcon; },
/* harmony export */   "PA": function() { return /* binding */ StyledRadioButton; },
/* harmony export */   "WH": function() { return /* binding */ StyledRadioButtonLabel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: ",
        ";\n  border: 2px solid ",
        ";\n  position: relative;\n  transition: 0.3s;\n  flex-shrink: 0;\n\n  &::after {\n    content: '';\n    width: ",
        ";\n    height: ",
        ";\n    border-radius: ",
        ";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: ",
        ";\n    opacity: 0;\n    transition: 0.3s;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      input[type='radio'] {\n        & + label {\n          border: 1px solid ",
        ";\n          border-radius: ",
        ";\n          padding: ",
        ";\n          box-shadow: ",
        ";\n          cursor: pointer;\n\n          font-weight: ",
        ";\n        }\n\n        &:checked + label {\n          background: ",
        ";\n          border-color: ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n\n  input[type='radio'] {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    padding: 0;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    border: 0;\n\n    &:checked + label ",
        " {\n      background-color: ",
        ";\n      border-color: ",
        ";\n\n      &::after {\n        opacity: 1;\n      }\n    }\n\n    &:hover + label ",
        " {\n      border-color: ",
        ";\n    }\n\n    &:checked:hover + label ",
        " {\n      border-color: ",
        ";\n      background-color: ",
        ";\n    }\n\n    &:focus + label ",
        " {\n      outline: 0;\n      border-color: ",
        ";\n      box-shadow: 0 0 0 4px ",
        ";\n    }\n\n    &[disabled] {\n      pointer-events: none;\n\n      & + label {\n        color: ",
        ";\n        pointer-events: none;\n\n        ",
        " {\n          border-color: ",
        ";\n          background-color: ",
        ";\n        }\n      }\n\n      &:checked + label ",
        " {\n        border-color: ",
        ";\n        background-color: ",
        ";\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      flex-direction: row-reverse;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  line-height: 1;\n  vertical-align: text-bottom;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StyledRadioButtonIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-17e359c5-0"
})(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .radius */ .q0)("full"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .radius */ .q0)("full"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"));
var StyledRadioButton = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-17e359c5-1"
})(_templateObject2(), StyledRadioButtonIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_800"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_800"), StyledRadioButtonIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_400"), StyledRadioButtonIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_600"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_600"), StyledRadioButtonIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_850"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_disabled"), StyledRadioButtonIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text-disabled"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), StyledRadioButtonIcon, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), function(param) {
    var isCard = param.isCard;
    return isCard && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .radius */ .q0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .shadow */ .AF)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("extraBold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("active"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("active"));
});
var StyledRadioButtonLabel = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-17e359c5-2"
})(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), function(param) {
    var isLabelReversed = param.isLabelReversed;
    return isLabelReversed && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3());
});


/***/ }),

/***/ 73273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _RadioButton_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45426);





var RadioButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var label = _param.label, id = _param.id, isLabelReversed = _param.isLabelReversed, _isCard = _param.isCard, isCard = _isCard === void 0 ? false : _isCard, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "label",
        "id",
        "isLabelReversed",
        "isCard"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_RadioButton_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledRadioButton */ .PA, {
        isCard: isCard,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                type: "radio",
                ref: ref,
                id: id
            }, other)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_RadioButton_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledRadioButtonLabel */ .WH, {
                htmlFor: id,
                isLabelReversed: isLabelReversed,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RadioButton_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledRadioButtonIcon */ .Jd, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: label
                    })
                ]
            })
        ]
    });
});
RadioButton.displayName = "RadioButton";
/* harmony default export */ __webpack_exports__["Z"] = (RadioButton);


/***/ }),

/***/ 80087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E$": function() { return /* binding */ StyledCopyWrapper; },
/* harmony export */   "It": function() { return /* binding */ StyledShareModalButtons; },
/* harmony export */   "ao": function() { return /* binding */ StyledCopyAnchor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-bottom: ",
        ";\n\n  > *:not(:last-child) {\n    margin-right: ",
        ";\n  }\n\n  @media (max-width: ",
        ") {\n    flex-wrap: wrap;\n    > * {\n      width: 2.5rem;\n      height: 2.5rem;\n\n      svg {\n        width: ",
        ";\n        height: ",
        ";\n      }\n\n      &:not(:last-child) {\n        margin-right: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-end;\n  flex-direction: column;\n  padding-right: 2rem;\n  line-height: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledShareModalButtons = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-724ab933-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("mdMax"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"));
var StyledCopyAnchor = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-724ab933-1"
})(_templateObject1());
var StyledCopyWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-724ab933-2"
})(_templateObject2());


/***/ }),

/***/ 9011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ShareModal": function() { return /* reexport */ ShareModal; },
  "default": function() { return /* binding */ shared_ShareModal; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(97143);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/TooltipMF.tsx
var TooltipMF = __webpack_require__(83885);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-modal/lib/index.js
var lib = __webpack_require__(37149);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
// EXTERNAL MODULE: ./components/shared/FormGroup.tsx
var FormGroup = __webpack_require__(74993);
// EXTERNAL MODULE: ./components/shared/InputText.tsx
var InputText = __webpack_require__(6776);
// EXTERNAL MODULE: ./components/shared/Modal.tsx
var Modal = __webpack_require__(61897);
// EXTERNAL MODULE: ./components/shared/ShareModal/ShareModal.styled.ts
var ShareModal_styled = __webpack_require__(80087);
;// CONCATENATED MODULE: ./components/shared/ShareModal/ShareModal.tsx













var ShareModal = function(param) {
    var twitterMessage = param.twitterMessage, telegramMessage = param.telegramMessage, whatsappMessage = param.whatsappMessage, emailMessage = param.emailMessage, emailSubject = param.emailSubject, isOpened = param.isOpened, close = param.close, url = param.url;
    var t = (0,useI18n/* useI18n */.Q)("common").t;
    var linkInputRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), copied = ref[0], setCopied = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
        isOpen: isOpened,
        contentLabel: t("share-modal.shareAction"),
        onAfterOpen: function() {
            setCopied(false);
        },
        shouldCloseOnOverlayClick: true,
        onRequestClose: close,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            title: t("share-modal.share"),
            onClose: close,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShareModal_styled/* StyledShareModalButtons */.It, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_styled/* default */.C, {
                                variant: "secondary",
                                sizes: "md",
                                isIcon: true,
                                href: "http://twitter.com/share?text=".concat(twitterMessage, "&url=").concat(encodeURIComponent(url)),
                                target: "_blank",
                                rel: "noreferrer",
                                title: t("share-modal.twitter"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    "aria-hidden": "true",
                                    icon: free_brands_svg_icons/* faTwitter */.mdU
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_styled/* default */.C, {
                                variant: "secondary",
                                sizes: "md",
                                isIcon: true,
                                href: "https://www.linkedin.com/shareArticle?mini=true&url=".concat(encodeURIComponent(url)),
                                target: "_blank",
                                rel: "noreferrer",
                                title: t("share-modal.linkedin"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    "aria-hidden": "true",
                                    icon: free_brands_svg_icons/* faLinkedin */.D9H
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_styled/* default */.C, {
                                variant: "secondary",
                                sizes: "md",
                                isIcon: true,
                                href: "https://telegram.me/share/url?url=".concat(encodeURIComponent(url), "&text=").concat(telegramMessage),
                                target: "_blank",
                                rel: "noreferrer",
                                title: t("share-modal.telegram"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    "aria-hidden": "true",
                                    icon: free_brands_svg_icons/* faTelegramPlane */.IKq
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_styled/* default */.C, {
                                variant: "secondary",
                                sizes: "md",
                                isIcon: true,
                                href: "https://api.whatsapp.com/send?text=".concat(whatsappMessage, " ").concat(encodeURIComponent(url)),
                                target: "_blank",
                                rel: "noreferrer",
                                title: t("share-modal.whatsapp"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    "aria-hidden": "true",
                                    icon: free_brands_svg_icons/* faWhatsapp */.VHX
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink_styled/* default */.C, {
                                variant: "secondary",
                                sizes: "md",
                                isIcon: true,
                                href: "mailto:?subject=".concat(encodeURIComponent(emailSubject), "&body=").concat(emailMessage, " ").concat(encodeURIComponent(url)),
                                target: "_blank",
                                rel: "noreferrer",
                                title: t("share-modal.email"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    "aria-hidden": "true",
                                    icon: free_solid_svg_icons/* faEnvelope */.FU$
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormGroup/* default */.Z, {
                        label: "".concat(t("share-modal.copyLink")),
                        forId: "shareLink",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputText/* default */.Z, {
                                id: "shareLink",
                                type: "text",
                                value: url,
                                title: url,
                                variant: "copy",
                                readOnly: true,
                                ref: linkInputRef,
                                onClick: function() {
                                    var ref;
                                    (ref = linkInputRef.current) === null || ref === void 0 ? void 0 : ref.select();
                                    document.execCommand("copy");
                                    setCopied(true);
                                    setTimeout(function() {
                                        setCopied(false);
                                    }, 2000);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal_styled/* StyledCopyWrapper */.E$, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipMF/* default */.Z, {
                                    content: t("share-modal.linkCopy"),
                                    direction: "up",
                                    distance: 65,
                                    isOpen: copied,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal_styled/* StyledCopyAnchor */.ao, {})
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/shared/ShareModal/index.ts


/* harmony default export */ var shared_ShareModal = (ShareModal);


/***/ }),

/***/ 99655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.Cd; },
/* harmony export */   "XJ": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.XJ; },
/* harmony export */   "aC": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.aC; },
/* harmony export */   "by": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.by; },
/* harmony export */   "k8": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.k8; },
/* harmony export */   "nL": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.nL; }
/* harmony export */ });
/* harmony import */ var _Typography_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90637);



/***/ }),

/***/ 90637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ Heading6; },
/* harmony export */   "XJ": function() { return /* binding */ Heading2; },
/* harmony export */   "aC": function() { return /* binding */ Heading3; },
/* harmony export */   "by": function() { return /* binding */ Heading5; },
/* harmony export */   "k8": function() { return /* binding */ Heading4; },
/* harmony export */   "nL": function() { return /* binding */ Heading1; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          width: ",
        ";\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.12;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var Heading1 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-f61a956f-0"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("cyan_700"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl5"));
var Heading2 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-f61a956f-1"
})(_templateObject7(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("indigo_500"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"));
var Heading3 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-f61a956f-2"
})(_templateObject10(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("mint_900"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject9(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"));
var Heading4 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-f61a956f-3"
})(_templateObject11(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"));
var Heading5 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h5.withConfig */ .ZP.h5.withConfig({
    componentId: "sc-f61a956f-4"
})(_templateObject12(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"));
var Heading6 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h6.withConfig */ .ZP.h6.withConfig({
    componentId: "sc-f61a956f-5"
})(_templateObject13(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"));


/***/ }),

/***/ 28619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hz": function() { return /* binding */ StyledContent; },
/* harmony export */   "SO": function() { return /* binding */ StyledTriggerIcon; },
/* harmony export */   "WQ": function() { return /* binding */ StyledSummary; },
/* harmony export */   "X0": function() { return /* binding */ StyledTitle; },
/* harmony export */   "iO": function() { return /* binding */ StyledDetails; },
/* harmony export */   "sB": function() { return /* binding */ StyledAccordion; },
/* harmony export */   "tr": function() { return /* binding */ StyledTrigger; },
/* harmony export */   "wW": function() { return /* binding */ StyledAccordionItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  margin: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.142;\n  font-weight: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  -webkit-appearance: none;\n  color: inherit;\n  cursor: pointer;\n  width: 100%;\n  padding: ",
        " 0;\n  display: flex;\n  align-items: center;\n  border: none;\n  background-color: transparent;\n  outline: none;\n  text-align: left;\n\n  &:focus-visible {\n    ",
        ":before {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: auto;\n  padding-left: ",
        ";\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n    transition: transform 0.3s ease-in-out;\n\n    .is-active & {\n      transform: rotate(180deg);\n      transform-origin: center center;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  margin: 0;\n  transition: max-height 0.3s ease-in-out;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-bottom: ",
        ";\n  font-size: ",
        ";\n\n  p {\n    margin: 0;\n    &:not(:first-child) {\n      margin-top: ",
        ";\n    }\n  }\n\n  ul,\n  ol {\n    margin-left: 1rem;\n  }\n\n  li {\n    list-style-type: disc;\n    margin: 0;\n  }\n\n  ol li {\n    list-style-type: decimal;\n  }\n\n  img {\n    display: block;\n    margin-top: ",
        ";\n    margin-left: auto;\n    margin-right: auto;\n\n    &:not(:last-child) {\n      margin-bottom: ",
        ";\n    }\n  }\n\n  figure {\n    margin: 0;\n  }\n\n  figcaption {\n    font-weight: ",
        ";\n    color: ",
        ";\n    margin-top: ",
        ";\n  }\n\n  blockquote {\n    margin: 0;\n    font-style: italic;\n  }\n\n  .slick-track {\n    display: flex;\n    justify-content: center;\n  }\n\n  .slick-slide {\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n\n  .slick-dots {\n    justify-content: flex-start;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var StyledAccordion = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dl.withConfig */ .ZP.dl.withConfig({
    componentId: "sc-72941c48-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"));
var StyledAccordionItem = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-72941c48-1"
})(_templateObject1());
var StyledSummary = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dt.withConfig */ .ZP.dt.withConfig({
    componentId: "sc-72941c48-2"
})(_templateObject2(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"));
var StyledTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-72941c48-3"
})(_templateObject3(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("sans"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"));
var StyledTrigger = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-72941c48-4"
})(_templateObject4(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), StyledTitle, (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("active"));
var StyledTriggerIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-72941c48-5"
})(_templateObject5(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"));
var StyledDetails = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dd.withConfig */ .ZP.dd.withConfig({
    componentId: "sc-72941c48-6"
})(_templateObject6());
var StyledContent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-72941c48-7"
})(_templateObject7(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("extraBold"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_subtle"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"));


/***/ }),

/***/ 71065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ accordion_Accordion; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/shared/accordion/Accordion.styled.tsx
var Accordion_styled = __webpack_require__(28619);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./components/shared/accordion/AccordionItem.tsx






var AccordionItem = function(param) {
    var summary = param.summary, details = param.details, active = param.active;
    var toggleAccordion = function toggleAccordion() {
        setIsActive(function(prev) {
            return !prev;
        });
    };
    var ref = (0,react.useState)(active), isActive = ref[0], setIsActive = ref[1];
    (0,react.useEffect)(function() {
        if (active) {
            setIsActive(active);
        }
    }, [
        active
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion_styled/* StyledAccordionItem */.wW, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_styled/* StyledSummary */.WQ, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion_styled/* StyledTrigger */.tr, {
                    className: classnames_default()({
                        "is-active": isActive
                    }),
                    onClick: toggleAccordion,
                    type: "button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_styled/* StyledTitle */.X0, {
                            children: summary
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_styled/* StyledTriggerIcon */.SO, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faCaretDown */.eW2
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_styled/* StyledDetails */.iO, {
                style: {
                    maxHeight: "".concat(isActive ? "1500px" : "0px")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_styled/* StyledContent */.Hz, {
                    children: details
                })
            })
        ]
    });
};
/* harmony default export */ var accordion_AccordionItem = (AccordionItem);

;// CONCATENATED MODULE: ./components/shared/accordion/Accordion.tsx



var Accordion = function(param) {
    var items = param.items;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_styled/* StyledAccordion */.sB, {
        children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_AccordionItem, {
                summary: item.summary,
                details: item.details,
                active: item.active
            }, index);
        })
    });
};
/* harmony default export */ var accordion_Accordion = (Accordion);


/***/ }),

/***/ 56002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ usePageTrack; }
});

// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useFeatureFlag/index.ts
var useFeatureFlag = __webpack_require__(84110);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
;// CONCATENATED MODULE: ./hooks/usePageTrack/usePageTrack.ts




var usePageTrack = function(event) {
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var ref1 = (0,useFeatureFlag/* useFeatureFlag */.y)("talent_manfredite_profile_page_tracking"), isEnabled = ref1.isEnabled, isLoadingFeatureFlag = ref1.isLoading;
    var alreadySent = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // Still loading feature flag values
        if (isLoadingFeatureFlag) {
            return;
        }
        // If event is "Public Profile - Page Loaded" and feature flag is disabled, do not track
        var isPublicProfileTrackDisabled = !isLoadingFeatureFlag && !isEnabled && event === "Public Profile - Page Loaded";
        if (isPublicProfileTrackDisabled) {
            return;
        }
        // When user info (if any) is already loaded and event is not tracked yet => Track it
        if (!alreadySent.current) {
            var urlParams = new URLSearchParams(window.location.search);
            // Identify user with campaign traits if user is logged in and campaign exists
            if (urlParams.get("utm_campaign")) {
                identifyUserWithCampaign(urlParams);
            }
            service_event_tracking/* default.page */.Z.page(event, {
                userId: (user === null || user === void 0 ? void 0 : user.id) ? "userId-".concat(user.id) : undefined
            });
            alreadySent.current = true;
        }
    }, [
        loadingUser,
        event,
        user === null || user === void 0 ? void 0 : user.id,
        isLoadingFeatureFlag,
        isEnabled
    ]);
};
function identifyUserWithCampaign(urlParams) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    service_event_tracking/* default.identifyAnonymous */.Z.identifyAnonymous({
        "campaign.name": ((ref = urlParams.get("utm_campaign")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || undefined,
        "campaign.source": ((ref1 = urlParams.get("utm_source")) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || undefined,
        "campaign.medium": ((ref2 = urlParams.get("utm_medium")) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || undefined,
        "campaign.term": ((ref3 = urlParams.get("utm_term")) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || undefined,
        "campaign.content": ((ref4 = urlParams.get("utm_content")) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) || undefined,
        "campaign.id": ((ref5 = urlParams.get("utm_id")) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) || undefined
    });
}

;// CONCATENATED MODULE: ./hooks/usePageTrack/index.ts



/***/ }),

/***/ 2940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ developer_career_report_2024; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 13 modules
var Page = __webpack_require__(9092);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/Button.js
var Button = __webpack_require__(15659);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./components/shared/ShareModal/index.ts + 1 modules
var ShareModal = __webpack_require__(9011);
// EXTERNAL MODULE: ./components/shared/TooltipMF.tsx
var TooltipMF = __webpack_require__(83885);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/shared/methodologyAnchor/MethodologyAnchor.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  color: inherit;\n  gap: ",
        ";\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n\n  svg {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledAnchor = (0,styled_components_browser_esm/* default */.ZP)(modules/* Link */.rU).withConfig({
    componentId: "sc-88ddec48-0"
})(_templateObject(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("xs2"), (0,theme/* color */.$_)("midnight_300"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/shared/methodologyAnchor/MethodologyAnchor.tsx





var MethodologyAnchor = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAnchor, {
        to: "methodology",
        href: "#methodology",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                icon: free_solid_svg_icons/* faInfoCircle */.sqG
            }),
            t("mantechcar24.methodology-anchor")
        ]
    });
};
/* harmony default export */ var methodologyAnchor_MethodologyAnchor = (MethodologyAnchor);

// EXTERNAL MODULE: ./components/shared/Typography.styled.tsx
var Typography_styled = __webpack_require__(90637);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/shared/sectionChart/SectionChart.styled.tsx

function SectionChart_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  background-color: transparent;\n  border: none;\n  appearance: none;\n  padding: 0;\n  cursor: pointer;\n  font-size: ",
        ";\n  display: none;\n  width: calc(",
        " + ",
        ");\n  margin-left: calc(-",
        " - ",
        ");\n  padding-right: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    SectionChart_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n  text-align: left;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  gap: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n\n  ",
        " {\n    > span {\n      display: flex;\n      align-items: center;\n    }\n    &:hover ",
        " {\n      display: block;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.5;\n  margin-top: 0;\n\n  &.isTop {\n    margin-top: -",
        ";\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var ShareTitle = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-497c75f1-0"
})(SectionChart_styled_templateObject(), (0,theme/* color */.$_)("midnight_300"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("midnight_400"));
var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-497c75f1-1"
})(_templateObject1(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), Typography_styled/* Heading2 */.XJ, ShareTitle);
var StyledDesc = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-497c75f1-2"
})(_templateObject2(), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("md"));
var StyledActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-497c75f1-3"
})(_templateObject3(), (0,theme/* spacing */.W0)("md"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/shared/sectionChart/SectionChart.tsx
















var SectionChart = function(param) {
    var title = param.title, children = param.children, desc = param.desc, descExtra = param.descExtra, shareId = param.shareId, shareMessage = param.shareMessage, emailMessage = param.emailMessage, emailSubject = param.emailSubject;
    var locale = (0,router.useRouter)().locale;
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    var ref = (0,react.useState)(false), isShareModalOpened = ref[0], setIsShareModalOpened = ref[1];
    var linkRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), copied = ref1[0], setCopied = ref1[1];
    var url;
    if (true) {
        url = "".concat(window.location.origin, "/").concat(locale).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.mantechcar24 */.uu.mantechcar24, locale), "#").concat(shareId);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        id: shareId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                as: "h3",
                editorial: true,
                alignLeft: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        shareId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareTitle, {
                                    ref: linkRef,
                                    onClick: function() {
                                        navigator.clipboard.writeText(url);
                                        setCopied(true);
                                        setTimeout(function() {
                                            setCopied(false);
                                        }, 2000);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_solid_svg_icons/* faLink */.nNP
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipMF/* default */.Z, {
                                    content: t("mantechcar24.copied"),
                                    direction: "up",
                                    distance: 65,
                                    isOpen: copied
                                })
                            ]
                        }),
                        title
                    ]
                })
            }),
            desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDesc, {
                className: "isTop",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                    ns: "developer-career-report-2024",
                    i18nKey: desc
                })
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledActions, {
                children: [
                    shareId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                        variant: "secondary",
                        type: "button",
                        onClick: function() {
                            service_event_tracking/* default.trackLandingCtaClicked */.Z.trackLandingCtaClicked("mandecar-compartir");
                            setIsShareModalOpened(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faShareSquare */.tFX
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("mantechcar24.footer-share")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
                ]
            }),
            descExtra && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDesc, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                    ns: "developer-career-report-2024",
                    i18nKey: descExtra
                })
            }),
            emailSubject && emailMessage && shareMessage && isShareModalOpened && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal["default"], {
                isOpened: isShareModalOpened,
                close: function() {
                    return setIsShareModalOpened(false);
                },
                url: "".concat(window.location.origin, "/").concat(locale).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.mantechcar24 */.uu.mantechcar24, locale), "#").concat(shareId),
                emailSubject: emailSubject,
                twitterMessage: shareMessage,
                telegramMessage: shareMessage,
                whatsappMessage: shareMessage,
                emailMessage: emailMessage
            })
        ]
    });
};
/* harmony default export */ var sectionChart_SectionChart = (SectionChart);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/shared/sectionHero/SectionHero.styled.tsx

function SectionHero_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  position: relative;\n  background-color: ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    SectionHero_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SectionHero_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.4;\n  z-index: 1;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n"
    ]);
    SectionHero_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SectionHero_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    max-width: 25rem;\n  }\n  @media (min-width: ",
        ") {\n    max-width: 34rem;\n  }\n"
    ]);
    SectionHero_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SectionHero_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  color: var(--headingColor);\n"
    ]);
    SectionHero_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n  font-family: ",
        ";\n  margin-bottom: ",
        ";\n\n  &::before {\n    background-color: var(--headingColor);\n    height: ",
        ";\n    top: calc(",
        " * -1);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.5;\n  max-width: ",
        ";\n  margin: 0 auto;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.2;\n  text-transform: uppercase;\n  letter-spacing: 0.35em;\n  margin-top: 0;\n  font-weight: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n\n  &::before,\n  &::after {\n    content: '';\n    height: 1px;\n    background-color: ",
        ";\n    flex-grow: 1;\n  }\n\n  &::before {\n    @media (max-width: ",
        ") {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var StyledHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43853e98-0"
})(SectionHero_styled_templateObject(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("sun_100"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl5"));
var StyledHeroContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43853e98-1"
})(SectionHero_styled_templateObject1(), (0,theme/* container */.nC)("xlMax"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"));
var StyledHeroImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-43853e98-2"
})(SectionHero_styled_templateObject2(), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("xl"));
var StyledHeroContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43853e98-3"
})(SectionHero_styled_templateObject3());
var StyledHeroTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography_styled/* Heading1 */.nL).withConfig({
    componentId: "sc-43853e98-4"
})(_templateObject4(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontFamily */.I8)("sans"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("lg"));
var StyledHeroDesc = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-43853e98-5"
})(_templateObject5(), (0,theme/* fontSize */.JB)("md"), (0,theme/* container */.nC)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43853e98-6"
})(_templateObject6(), (0,theme/* spacing */.W0)("xl4"));
var StyledDataTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-43853e98-7"
})(_templateObject7(), (0,theme/* fontFamily */.I8)("sans"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("white"), (0,theme/* screen */.sp)("mdMax"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/shared/sectionHero/SectionHero.tsx



var SectionHero = function(param) {
    var image = param.image, title = param.title, desc = param.desc;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHero, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroImage, {
                    src: image,
                    alt: ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroTitle, {
                            as: "h2",
                            editorial: true,
                            alignLeft: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                ns: "developer-career-report-2024",
                                i18nKey: title
                            })
                        }),
                        desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroDesc, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                ns: "developer-career-report-2024",
                                i18nKey: desc
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var sectionHero_SectionHero = (SectionHero);

// EXTERNAL MODULE: ./components/shared/RadioButton.tsx
var RadioButton = __webpack_require__(73273);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/shared/switcher/Switcher.styled.tsx

function Switcher_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin: 0 0 ",
        ";\n  border: 0;\n  padding: 0;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: center;\n    gap: ",
        ";\n  }\n\n  legend {\n    font-weight: ",
        ";\n    float: left;\n    padding: 0;\n  }\n"
    ]);
    Switcher_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Switcher_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  &.is-active {\n    display: block;\n  }\n"
    ]);
    Switcher_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledSwitcher = styled_components_browser_esm/* default.fieldset.withConfig */.ZP.fieldset.withConfig({
    componentId: "sc-f1ffb830-0"
})(Switcher_styled_templateObject(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontWeight */.Ue)("black"));
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f1ffb830-1"
})(Switcher_styled_templateObject1());

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/shared/switcher/Switcher.tsx




var Switcher = function(param) {
    var tabsName = param.tabsName, tabs = param.tabs, label = param.label;
    var defaultTabChecked = tabs.findIndex(function(tab) {
        return tab.defaultChecked === true;
    });
    var defaultTabCheckedPosition = defaultTabChecked >= 0 ? defaultTabChecked : 0;
    var ref = (0,react.useState)(tabs[defaultTabCheckedPosition].id), activeTab = ref[0], setActiveTab = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwitcher, {
                role: "tablist",
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                        children: label
                    }),
                    tabs.map(function(tab, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                            name: tabsName,
                            id: tab.id,
                            label: tab.label,
                            "aria-controls": tab.id + "_content",
                            "aria-selected": activeTab === tab.id,
                            onChange: function() {
                                return setActiveTab(tab.id);
                            },
                            checked: activeTab === tab.id
                        }, index);
                    })
                ]
            }),
            tabs.map(function(tab, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContent, {
                    id: tab.id + "_content",
                    role: "tabpanel",
                    "aria-labelledby": tab.id,
                    className: activeTab === tab.id ? "is-active" : "",
                    children: tab.content
                }, index);
            })
        ]
    });
};
/* harmony default export */ var switcher_Switcher = (Switcher);

;// CONCATENATED MODULE: ./data/mantechcar24/salary-by-role-and-experience.json
var salary_by_role_and_experience_namespaceObject = JSON.parse('[{"role":"Backend Developer","exp":"0-2","tier1":70.69109075770191,"tier2":17.68526228143214,"tier3":5.745212323064113,"tier4":2.364696086594505,"tier5":1.8651124063280602,"tier6":1.6486261448792672},{"role":"Backend Developer","exp":"2-5","tier1":22.063116919227028,"tier2":32.72626164326429,"tier3":22.73043236479911,"tier4":9.870707632420409,"tier5":8.772417628249688,"tier6":3.8370638120394833},{"role":"Backend Developer","exp":"5-10","tier1":5.269645608628659,"tier2":18.274268104776578,"tier3":24.992295839753467,"tier4":19.090909090909093,"tier5":21.15562403697997,"tier6":11.217257318952234},{"role":"Backend Developer","exp":"10-","tier1":3.77541142303969,"tier2":11.96515004840271,"tier3":23.13649564375605,"tier4":20.716360116166506,"tier5":24.511132623426914,"tier6":15.895450145208132},{"role":"Data Analyst & BI","exp":"0-2","tier1":64.77045908183634,"tier2":23.053892215568865,"tier3":6.487025948103792,"tier4":2.19560878243513,"tier5":1.5968063872255487,"tier6":1.8962075848303395},{"role":"Data Analyst & BI","exp":"2-5","tier1":18.51851851851852,"tier2":31.263616557734203,"tier3":28.75816993464052,"tier4":11.655773420479303,"tier5":6.535947712418301,"tier6":3.2679738562091507},{"role":"Data Analyst & BI","exp":"5-10","tier1":7.624113475177305,"tier2":19.680851063829788,"tier3":28.54609929078014,"tier4":21.98581560283688,"tier5":16.48936170212766,"tier6":5.673758865248227},{"role":"Data Analyst & BI","exp":"10-","tier1":5.75139146567718,"tier2":14.471243042671613,"tier3":24.675324675324674,"tier4":20.222634508348794,"tier5":25.04638218923933,"tier6":9.833024118738404},{"role":"Data Engineer","exp":"0-2","tier1":47.69381746810598,"tier2":32.482826300294406,"tier3":9.028459273797841,"tier4":4.023552502453385,"tier5":3.3366045142296366,"tier6":3.434739941118744},{"role":"Data Engineer","exp":"2-5","tier1":12.239800166527894,"tier2":26.061615320566194,"tier3":28.39300582847627,"tier4":16.153205661948377,"tier5":12.572855953372189,"tier6":4.579517069109076},{"role":"Data Engineer","exp":"5-10","tier1":2.8500619578686495,"tier2":11.648079306071871,"tier3":21.561338289962826,"tier4":25.03097893432466,"tier5":24.65923172242875,"tier6":14.250309789343246},{"role":"Data Engineer","exp":"10-","tier1":3.8520801232665636,"tier2":7.858243451463791,"tier3":18.02773497688752,"tier4":18.181818181818183,"tier5":30.662557781201848,"tier6":21.417565485362093},{"role":"Data Scientist","exp":"0-2","tier1":44.45973847212664,"tier2":33.44803854094976,"tier3":12.18169304886442,"tier4":4.198210598761184,"tier5":3.64762560220234,"tier6":2.064693737095664},{"role":"Data Scientist","exp":"2-5","tier1":10.88680605623648,"tier2":28.767123287671232,"tier3":28.262436914203313,"tier4":15.501081470800287,"tier5":11.968276856524874,"tier6":4.6142754145638065},{"role":"Data Scientist","exp":"5-10","tier1":4.663923182441701,"tier2":12.071330589849108,"tier3":21.67352537722908,"tier4":24.142661179698216,"tier5":23.319615912208505,"tier6":14.12894375857339},{"role":"Data Scientist","exp":"10-","tier1":5.251141552511415,"tier2":9.1324200913242,"tier3":18.2648401826484,"tier4":18.2648401826484,"tier5":29.68036529680365,"tier6":19.406392694063925},{"role":"DevOps & Infrastructure & SRE","exp":"0-2","tier1":48.90190336749634,"tier2":26.79355783308931,"tier3":11.859443631039532,"tier4":5.563689604685212,"tier5":4.978038067349927,"tier6":1.903367496339678},{"role":"DevOps & Infrastructure & SRE","exp":"2-5","tier1":11.349957007738606,"tier2":23.301805674978503,"tier3":26.741186586414443,"tier4":18.056749785038694,"tier5":14.273430782459156,"tier6":6.276870163370593},{"role":"DevOps & Infrastructure & SRE","exp":"5-10","tier1":3.9441248972884138,"tier2":10.928512736236648,"tier3":18.077239112571895,"tier4":21.03533278553821,"tier5":30.156121610517665,"tier6":15.858668857847166},{"role":"DevOps & Infrastructure & SRE","exp":"10-","tier1":3.6630036630036633,"tier2":6.73992673992674,"tier3":15.75091575091575,"tier4":19.926739926739927,"tier5":30.76923076923077,"tier6":23.15018315018315},{"role":"Engineering Management","exp":"0-2","tier1":23.25581395348837,"tier2":29.651162790697676,"tier3":18.023255813953487,"tier4":11.046511627906977,"tier5":5.232558139534884,"tier6":12.790697674418606},{"role":"Engineering Management","exp":"2-5","tier1":7.363420427553444,"tier2":18.28978622327791,"tier3":22.802850356294538,"tier4":20.665083135391924,"tier5":19.002375296912113,"tier6":11.87648456057007},{"role":"Engineering Management","exp":"5-10","tier1":0.8365508365508365,"tier2":6.628056628056628,"tier3":13.8996138996139,"tier4":18.91891891891892,"tier5":31.53153153153153,"tier6":28.185328185328185},{"role":"Engineering Management","exp":"10-","tier1":0.875979714153988,"tier2":3.1350852927616413,"tier3":7.745504840940526,"tier4":13.739050253573076,"tier5":35.361917934532045,"tier6":39.14246196403873},{"role":"Frontend Developer","exp":"0-2","tier1":71.58946700507614,"tier2":16.71954314720812,"tier3":5.440989847715736,"tier4":2.7442893401015227,"tier5":1.8401015228426396,"tier6":1.6656091370558377},{"role":"Frontend Developer","exp":"2-5","tier1":27.311208940060954,"tier2":32.593972231628854,"tier3":19.45479173721639,"tier4":8.584490348797832,"tier5":8.787673552319674,"tier6":3.2678631899762953},{"role":"Frontend Developer","exp":"5-10","tier1":6.697857670524502,"tier2":18.763851268160554,"tier3":24.427480916030532,"tier4":17.655749815316423,"tier5":20.70918492982024,"tier6":11.745875400147748},{"role":"Frontend Developer","exp":"10-","tier1":5.948869223205507,"tier2":14.454277286135694,"tier3":24.237954768928223,"tier4":20.599803343166176,"tier5":21.632251720747295,"tier6":13.126843657817108},{"role":"Full-Stack Developer","exp":"0-2","tier1":70.06511627906977,"tier2":18.065116279069766,"tier3":6.083720930232558,"tier4":2.66046511627907,"tier5":1.5813953488372092,"tier6":1.544186046511628},{"role":"Full-Stack Developer","exp":"2-5","tier1":24.141483516483518,"tier2":32.45192307692308,"tier3":20.65590659340659,"tier4":9.581043956043956,"tier5":9.168956043956044,"tier6":4.000686813186813},{"role":"Full-Stack Developer","exp":"5-10","tier1":5.685257241677475,"tier2":18.849978383052314,"tier3":25.702550799827062,"tier4":17.61781236489408,"tier5":20.946822308690013,"tier6":11.197578901859059},{"role":"Full-Stack Developer","exp":"10-","tier1":4.073075771188979,"tier2":12.608565438754118,"tier3":23.59988020365379,"tier4":20.545073375262053,"tier5":24.049116501946692,"tier6":15.124288709194369},{"role":"Machine Learning Engineer","exp":"0-2","tier1":60.705882352941174,"tier2":25.647058823529413,"tier3":6.352941176470588,"tier4":3.294117647058824,"tier5":1.1764705882352942,"tier6":2.823529411764706},{"role":"Machine Learning Engineer","exp":"2-5","tier1":13.901345291479823,"tier2":28.02690582959641,"tier3":30.717488789237667,"tier4":16.143497757847534,"tier5":8.520179372197308,"tier6":2.690582959641256},{"role":"Machine Learning Engineer","exp":"5-10","tier1":3.8793103448275863,"tier2":9.913793103448276,"tier3":23.275862068965516,"tier4":26.29310344827586,"tier5":25,"tier6":11.637931034482758},{"role":"Machine Learning Engineer","exp":"10-","tier1":4.40251572327044,"tier2":10.062893081761008,"tier3":12.578616352201259,"tier4":21.38364779874214,"tier5":29.559748427672954,"tier6":22.0125786163522},{"role":"Mobile Developer","exp":"0-2","tier1":67.47614917606245,"tier2":17.519514310494362,"tier3":6.678230702515179,"tier4":3.2090199479618384,"tier5":2.3417172593235036,"tier6":2.7753686036426712},{"role":"Mobile Developer","exp":"2-5","tier1":20.24922118380062,"tier2":30.140186915887853,"tier3":24.45482866043614,"tier4":10.358255451713395,"tier5":10.358255451713395,"tier6":4.439252336448598},{"role":"Mobile Developer","exp":"5-10","tier1":6.003159557661927,"tier2":15.876777251184834,"tier3":19.90521327014218,"tier4":19.431279620853083,"tier5":24.24960505529226,"tier6":14.533965244865717},{"role":"Mobile Developer","exp":"10-","tier1":1.5406162464985995,"tier2":9.523809523809524,"tier3":19.047619047619047,"tier4":21.288515406162464,"tier5":25.770308123249297,"tier6":22.829131652661065},{"role":"Product Design (UI/UX)","exp":"0-2","tier1":74.52830188679245,"tier2":17.547169811320753,"tier3":4.528301886792453,"tier4":1.1320754716981132,"tier5":0.9433962264150944,"tier6":1.3207547169811322},{"role":"Product Design (UI/UX)","exp":"2-5","tier1":34.26356589147287,"tier2":40.93023255813954,"tier3":15.813953488372093,"tier4":3.875968992248062,"tier5":3.255813953488372,"tier6":1.8604651162790697},{"role":"Product Design (UI/UX)","exp":"5-10","tier1":13.644859813084112,"tier2":29.906542056074763,"tier3":31.775700934579437,"tier4":12.710280373831775,"tier5":7.663551401869159,"tier6":4.299065420560748},{"role":"Product Design (UI/UX)","exp":"10-","tier1":12.442396313364055,"tier2":26.036866359447004,"tier3":23.963133640552993,"tier4":14.285714285714285,"tier5":12.672811059907835,"tier6":10.599078341013826},{"role":"Product Manager","exp":"0-2","tier1":42.06349206349206,"tier2":34.12698412698413,"tier3":13.492063492063492,"tier4":7.142857142857142,"tier5":2.380952380952381,"tier6":0.7936507936507936},{"role":"Product Manager","exp":"2-5","tier1":12.015503875968992,"tier2":27.51937984496124,"tier3":34.883720930232556,"tier4":15.503875968992247,"tier5":7.945736434108527,"tier6":2.131782945736434},{"role":"Product Manager","exp":"5-10","tier1":3.2196969696969697,"tier2":12.878787878787879,"tier3":36.93181818181818,"tier4":21.401515151515152,"tier5":18.75,"tier6":6.8181818181818175},{"role":"Product Manager","exp":"10-","tier1":2.446043165467626,"tier2":6.18705035971223,"tier3":20.575539568345324,"tier4":23.453237410071942,"tier5":33.9568345323741,"tier6":13.381294964028779},{"role":"Project Manager & Delivery Manager","exp":"0-2","tier1":34.53237410071942,"tier2":34.172661870503596,"tier3":16.546762589928058,"tier4":7.913669064748201,"tier5":5.0359712230215825,"tier6":1.7985611510791366},{"role":"Project Manager & Delivery Manager","exp":"2-5","tier1":10.618436406067678,"tier2":29.75495915985998,"tier3":30.80513418903151,"tier4":14.585764294049008,"tier5":10.851808634772462,"tier6":3.38389731621937},{"role":"Project Manager & Delivery Manager","exp":"5-10","tier1":5.352591333899745,"tier2":15.80288870008496,"tier3":27.017841971113,"tier4":19.711129991503824,"tier5":21.665250637213255,"tier6":10.450297366185216},{"role":"Project Manager & Delivery Manager","exp":"10-","tier1":2.1465968586387434,"tier2":7.74869109947644,"tier3":19.581151832460733,"tier4":23.24607329842932,"tier5":32.82722513089006,"tier6":14.45026178010471},{"role":"QA & Testing","exp":"0-2","tier1":61.376673040152966,"tier2":21.03250478011472,"tier3":8.221797323135755,"tier4":3.824091778202677,"tier5":2.48565965583174,"tier6":3.0592734225621414},{"role":"QA & Testing","exp":"2-5","tier1":21.161290322580644,"tier2":34.96774193548387,"tier3":22.70967741935484,"tier4":12.387096774193548,"tier5":6.193548387096774,"tier6":2.5806451612903225},{"role":"QA & Testing","exp":"5-10","tier1":8.459214501510575,"tier2":19.033232628398792,"tier3":22.507552870090635,"tier4":22.80966767371601,"tier5":20.090634441087612,"tier6":7.099697885196375},{"role":"QA & Testing","exp":"10-","tier1":4.356846473029045,"tier2":14.107883817427386,"tier3":23.029045643153527,"tier4":20.539419087136928,"tier5":26.970954356846473,"tier6":10.995850622406639},{"role":"Scrum Master & Agile Coach","exp":"0-2","tier1":59.183673469387756,"tier2":24.489795918367346,"tier3":9.183673469387756,"tier4":4.081632653061225,"tier5":1.0204081632653061,"tier6":2.0408163265306123},{"role":"Scrum Master & Agile Coach","exp":"2-5","tier1":19.25465838509317,"tier2":35.40372670807454,"tier3":25.465838509316768,"tier4":14.285714285714285,"tier5":3.7267080745341614,"tier6":1.8633540372670807},{"role":"Scrum Master & Agile Coach","exp":"5-10","tier1":6.694560669456067,"tier2":21.338912133891213,"tier3":35.146443514644346,"tier4":22.17573221757322,"tier5":11.715481171548117,"tier6":2.928870292887029},{"role":"Scrum Master & Agile Coach","exp":"10-","tier1":4.017857142857143,"tier2":8.035714285714286,"tier3":29.24107142857143,"tier4":25.892857142857146,"tier5":27.00892857142857,"tier6":5.803571428571429},{"role":"Software Architect","exp":"0-2","tier1":45.34005037783375,"tier2":28.71536523929471,"tier3":10.327455919395465,"tier4":6.297229219143577,"tier5":4.282115869017632,"tier6":5.037783375314862},{"role":"Software Architect","exp":"2-5","tier1":9.570552147239264,"tier2":22.699386503067483,"tier3":27.484662576687118,"tier4":18.282208588957054,"tier5":14.23312883435583,"tier6":7.730061349693251},{"role":"Software Architect","exp":"5-10","tier1":1.2624934245134138,"tier2":6.049447659126775,"tier3":16.359810625986324,"tier4":21.72540768016833,"tier5":30.878485007890582,"tier6":23.72435560231457},{"role":"Software Architect","exp":"10-","tier1":1.3045434098065678,"tier2":3.553756185335133,"tier3":12.550607287449392,"tier4":18.173639226270804,"tier5":32.928475033738195,"tier6":31.488978857399907},{"role":"SysAdmin","exp":"0-2","tier1":77.57009345794393,"tier2":15.887850467289718,"tier3":2.336448598130841,"tier4":1.4018691588785046,"tier5":1.4018691588785046,"tier6":1.4018691588785046},{"role":"SysAdmin","exp":"2-5","tier1":35.2112676056338,"tier2":36.61971830985916,"tier3":17.6056338028169,"tier4":8.098591549295776,"tier5":2.112676056338028,"tier6":0.35211267605633806},{"role":"SysAdmin","exp":"5-10","tier1":20.8955223880597,"tier2":30.597014925373134,"tier3":23.134328358208954,"tier4":12.313432835820896,"tier5":10.074626865671641,"tier6":2.9850746268656714},{"role":"SysAdmin","exp":"10-","tier1":11.15702479338843,"tier2":26.239669421487605,"tier3":24.586776859504134,"tier4":18.388429752066116,"tier5":13.842975206611571,"tier6":5.785123966942149},{"role":"Tech Lead","exp":"0-2","tier1":31.57894736842105,"tier2":30.263157894736842,"tier3":11.842105263157894,"tier4":14.473684210526317,"tier5":5.263157894736842,"tier6":6.578947368421052},{"role":"Tech Lead","exp":"2-5","tier1":7.158836689038031,"tier2":24.832214765100673,"tier3":28.635346756152124,"tier4":23.042505592841163,"tier5":11.185682326621924,"tier6":5.1454138702460845},{"role":"Tech Lead","exp":"5-10","tier1":1.6353229762878168,"tier2":7.686017988552739,"tier3":22.894521668029437,"tier4":26.410466067048244,"tier5":29.10874897792314,"tier6":12.264922322158627},{"role":"Tech Lead","exp":"10-","tier1":1.3577023498694516,"tier2":4.02088772845953,"tier3":15.718015665796345,"tier4":24.699738903394255,"tier5":33.78590078328982,"tier6":20.4177545691906}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/benefits/AverageSalaryByRole.styled.tsx

function AverageSalaryByRole_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-x: auto;\n"
    ]);
    AverageSalaryByRole_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AverageSalaryByRole_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: min-content;\n  border-collapse: collapse;\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  thead th {\n    border-bottom: 1px solid ",
        ";\n    font-size: ",
        ";\n    line-height: 1.14;\n    padding-bottom: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  tbody th {\n    text-align: right;\n    font-weight: ",
        ";\n    padding-right: ",
        ";\n    white-space: nowrap;\n  }\n\n  tbody tr {\n    transition: 0.3s;\n  }\n\n  tr:first-of-type th,\n  tr:first-of-type td {\n    padding-top: ",
        ";\n  }\n\n  &:hover tbody tr {\n    opacity: 0.5;\n  }\n\n  tbody tr:hover {\n    opacity: 1;\n  }\n"
    ]);
    AverageSalaryByRole_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AverageSalaryByRole_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  min-width: 7.5rem;\n  height: 2.25rem;\n  border-radius: ",
        ";\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  &.cell-color-1 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n  &.cell-color-2 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n  &.cell-color-3 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n  &.cell-color-4 {\n    background-color: ",
        ";\n  }\n  &.cell-color-5 {\n    background-color: ",
        ";\n  }\n  &.cell-color-6 {\n    background-color: ",
        ";\n  }\n  &.cell-color-7 {\n    background-color: ",
        ";\n  }\n  &.cell-color-8 {\n    background-color: ",
        ";\n  }\n"
    ]);
    AverageSalaryByRole_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var AverageSalaryByRole_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-88eaa7d6-0"
})(AverageSalaryByRole_styled_templateObject());
var StyledTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-88eaa7d6-1"
})(AverageSalaryByRole_styled_templateObject1(), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"));
var StyledValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-88eaa7d6-2"
})(AverageSalaryByRole_styled_templateObject2(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* radius */.q0)("sm"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("white"), (0,theme/* color */.$_)("text_disabled"), (0,theme/* color */.$_)("seq_blue_03"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* color */.$_)("seq_blue_04"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* color */.$_)("seq_blue_05"), (0,theme/* color */.$_)("seq_blue_06"), (0,theme/* color */.$_)("seq_blue_07"), (0,theme/* color */.$_)("seq_blue_08"), (0,theme/* color */.$_)("seq_blue_09"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/benefits/AverageSalaryByRole.tsx



var AverageSalaryByRole = function(param) {
    var experience = param.experience;
    var filteredData = salary_by_role_and_experience_namespaceObject.filter(function(e) {
        return e.exp === experience;
    });
    var getClassColor = function(val) {
        if (val === 0) {
            return "cell-color-1";
        }
        if (val > 0 && val <= 5) {
            return "cell-color-2";
        }
        if (val > 5 && val <= 9) {
            return "cell-color-3";
        }
        if (val > 9 && val <= 14) {
            return "cell-color-4";
        }
        if (val > 14 && val <= 19) {
            return "cell-color-5";
        }
        if (val > 19 && val <= 24) {
            return "cell-color-6";
        }
        if (val > 24 && val <= 29) {
            return "cell-color-7";
        }
        if (val > 29) {
            return "cell-color-8";
        } else {
            return "cell-color-1";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AverageSalaryByRole_styled_StyledContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "€20-30K"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "€31-40K"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "€41-50K"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "€51-60K"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "€61-80K"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: ">80K"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: filteredData.map(function(data, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: data.role
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                        className: getClassColor(data.tier1),
                                        children: [
                                            data.tier1.toFixed(1),
                                            "%"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                        className: getClassColor(data.tier2),
                                        children: [
                                            data.tier2.toFixed(1),
                                            "%"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                        className: getClassColor(data.tier3),
                                        children: [
                                            data.tier3.toFixed(1),
                                            "%"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                        className: getClassColor(data.tier4),
                                        children: [
                                            data.tier4.toFixed(1),
                                            "%"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                        className: getClassColor(data.tier5),
                                        children: [
                                            data.tier5.toFixed(1),
                                            "%"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                        className: getClassColor(data.tier6),
                                        children: [
                                            data.tier6.toFixed(1),
                                            "%"
                                        ]
                                    })
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var benefits_AverageSalaryByRole = (AverageSalaryByRole);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/benefits/Benefits.constants.tsx


var AVERAGESALARYBYROLEANDEXPERIENCETABS = function(t) {
    return {
        label: t("mantechcar24.benefits.average-salary-role.experience"),
        tabsName: "averageSalaryByRoleAndExperience",
        tabs: [
            {
                id: "exp-2",
                label: "<2 " + t("mantechcar24.benefits.average-salary-role.years"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_AverageSalaryByRole, {
                    experience: "0-2"
                })
            },
            {
                id: "exp2-5",
                label: "2-5 " + t("mantechcar24.benefits.average-salary-role.years"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_AverageSalaryByRole, {
                    experience: "2-5"
                })
            },
            {
                id: "exp5-10",
                label: "5-10 " + t("mantechcar24.benefits.average-salary-role.years"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_AverageSalaryByRole, {
                    experience: "5-10"
                })
            },
            {
                id: "exp+10",
                label: ">10 " + t("mantechcar24.benefits.average-salary-role.years"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_AverageSalaryByRole, {
                    experience: "10-"
                }),
                defaultChecked: true
            }
        ]
    };
};

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/benefits/Benefits.styled.tsx

function Benefits_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    background-color: ",
        ";\n  }\n\n  ",
        " ",
        "::before {\n    background-color: ",
        ";\n  }\n"
    ]);
    Benefits_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5f5a26a-0"
})(Benefits_styled_templateObject(), StyledHero, (0,theme/* color */.$_)("cyan_100"), StyledContainer, Typography_styled/* Heading2 */.XJ, (0,theme/* color */.$_)("cyan_500"));

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./data/mantechcar24/location-preference.json
var location_preference_namespaceObject = JSON.parse('[{"type":"remote","prefersValue":65.73820275679833,"offeredValue":81.83306055646482,"label":"mantechcar24.benefits.location.remote"},{"type":"hybrid","prefersValue":35.95768176529747,"offeredValue":16.0392798690671,"label":"mantechcar24.benefits.location.hybrid"},{"type":"onsite","prefersValue":7.933190037664412,"offeredValue":2.127659574468085,"label":"mantechcar24.benefits.location.onsite"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/benefits/LocationPreference.styled.tsx

function LocationPreference_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  gap: ",
        ";\n  text-align: center;\n  margin: 0;\n  transition: 0.3s;\n"
    ]);
    LocationPreference_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: flex-end;\n    max-width: min-content;\n  }\n"
    ]);
    LocationPreference_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.25;\n  white-space: nowrap;\n"
    ]);
    LocationPreference_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  justify-items: center;\n  align-items: end;\n\n  > div {\n    border-radius: ",
        ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: calc(var(--coeficient) * 15rem);\n    aspect-ratio: 1/1;\n    grid-column-start: 1;\n    grid-row-start: 1;\n\n    @media (min-width: ",
        ") {\n      width: calc(var(--coeficient) * 19.5rem);\n    }\n  }\n"
    ]);
    LocationPreference_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    LocationPreference_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n\n  &.reverse {\n    z-index: -1;\n  }\n"
    ]);
    LocationPreference_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    LocationPreference_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  white-space: nowrap;\n\n  &::before {\n    content: '';\n    width: ",
        ";\n    height: ",
        ";\n    border-radius: ",
        ";\n    background-color: ",
        ";\n  }\n\n  &:nth-child(2)::before {\n    background-color: ",
        ";\n  }\n"
    ]);
    LocationPreference_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: ",
        ";\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: flex-start;\n  }\n\n  img {\n    max-width: 15.5rem;\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1.5;\n\n  p {\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var StyledItem = styled_components_browser_esm/* default.figure.withConfig */.ZP.figure.withConfig({
    componentId: "sc-a0f8214-0"
})(LocationPreference_styled_templateObject(), (0,theme/* spacing */.W0)("md"));
var StyledItems = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0f8214-1"
})(LocationPreference_styled_templateObject1(), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"));
var StyledCaption = styled_components_browser_esm/* default.figcaption.withConfig */.ZP.figcaption.withConfig({
    componentId: "sc-a0f8214-2"
})(LocationPreference_styled_templateObject2(), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("xl2"));
var StyledValueContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0f8214-3"
})(LocationPreference_styled_templateObject3(), (0,theme/* radius */.q0)("full"), (0,theme/* screen */.sp)("lg"));
var StyledPrefersValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0f8214-4"
})(LocationPreference_styled_templateObject4(), (0,theme/* color */.$_)("seq_blue_08"));
var StyledOfferedValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0f8214-5"
})(LocationPreference_styled_templateObject5(), (0,theme/* color */.$_)("seq_blue_05"));
var StyledLegend = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0f8214-6"
})(LocationPreference_styled_templateObject6(), (0,theme/* spacing */.W0)("sm"));
var StyledLegendItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0f8214-7"
})(LocationPreference_styled_templateObject7(), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* radius */.q0)("sm"), (0,theme/* color */.$_)("seq_blue_08"), (0,theme/* color */.$_)("seq_blue_05"));
var LocationPreference_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0f8214-8"
})(_templateObject8(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* radius */.q0)("lg"));
var StyledText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a0f8214-9"
})(_templateObject9());

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/benefits/LocationPreference.tsx





var LocationPreference = function() {
    var _Math;
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    var maxValue = (_Math = Math).max.apply(_Math, (0,_to_consumable_array/* default */.Z)(location_preference_namespaceObject.map(function(obj) {
        if (obj.prefersValue >= obj.offeredValue) {
            return obj.prefersValue;
        } else {
            return obj.offeredValue;
        }
    })));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItems, {
            children: location_preference_namespaceObject.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCaption, {
                            children: t(item.label)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValueContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPrefersValue, {
                                    style: {
                                        "--coeficient": item.prefersValue / maxValue
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOfferedValue, {
                                    className: item.offeredValue > item.prefersValue ? "reverse" : "",
                                    style: {
                                        "--coeficient": item.offeredValue / maxValue
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLegend, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLegendItem, {
                                    children: [
                                        t("mantechcar24.benefits.location.preference"),
                                        ":",
                                        " ",
                                        item.prefersValue.toFixed(1),
                                        "%"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLegendItem, {
                                    children: [
                                        t("mantechcar24.benefits.location.offer"),
                                        ":",
                                        " ",
                                        item.offeredValue.toFixed(1),
                                        "%"
                                    ]
                                })
                            ]
                        })
                    ]
                }, item.type);
            })
        })
    });
};
/* harmony default export */ var benefits_LocationPreference = (LocationPreference);

;// CONCATENATED MODULE: ./data/mantechcar24/salary-by-english-level.json
var salary_by_english_level_namespaceObject = JSON.parse('[{"years":{"en":"<2 years","es":"<2 años"},"basic":26713,"intermediate":32929,"fluent":25822,"native":28237},{"years":{"en":"2-5 years","es":"2-5 años"},"basic":31064,"intermediate":43995,"fluent":36866,"native":39969},{"years":{"en":"5-10 years","es":"5-10 años"},"basic":38600,"intermediate":56588,"fluent":52078,"native":59089},{"years":{"en":">10 years","es":">10 años"},"basic":44544,"intermediate":62069,"fluent":62380,"native":79726}]');
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/ResponsiveContainer.js + 1 modules
var ResponsiveContainer = __webpack_require__(61660);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/LineChart.js
var LineChart = __webpack_require__(32908);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/XAxis.js
var XAxis = __webpack_require__(25556);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/YAxis.js
var YAxis = __webpack_require__(3131);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(47857);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/Legend.js + 1 modules
var Legend = __webpack_require__(55734);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/Line.js
var Line = __webpack_require__(63004);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/shared/recharts/Recharts.styled.tsx

function Recharts_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: hidden;\n  overflow-x: hidden;\n\n  @media (max-width: ",
        ") {\n    overflow-x: auto;\n  }\n\n  .recharts-surface {\n    max-height: 100%;\n    border-radius: ",
        " !important;\n    flex: 0 0 auto;\n    align-self: flex-start;\n    margin-top: 3px;\n  }\n\n  .recharts-cartesian-axis-line {\n    stroke: ",
        ";\n  }\n\n  .recharts-text {\n    fill: ",
        ";\n    font-size: ",
        ";\n    text-transform: uppercase;\n    font-weight: ",
        ";\n  }\n  &.dark {\n    .recharts-text {\n      fill: ",
        ";\n    }\n    .recharts-legend-item-text {\n      color: ",
        " !important;\n    }\n    .recharts-cartesian-axis-line {\n      stroke: ",
        ";\n    }\n  }\n  &.skills {\n    .recharts-text {\n      fill: ",
        ";\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      text-transform: unset;\n    }\n  }\n  &.methodology {\n    .recharts-text {\n      font-size: ",
        ";\n      text-transform: unset;\n    }\n  }\n  &.gender-by-role {\n    .recharts-text {\n      font-size: ",
        ";\n    }\n  }\n\n  .recharts-label {\n    text-transform: inherit;\n    fill: ",
        ";\n  }\n\n  .recharts-label-list {\n    text-transform: inherit;\n    fill: ",
        ";\n    transform: translateZ(0);\n  }\n\n  .recharts-legend-wrapper {\n    right: -",
        " !important;\n  }\n\n  &.legend-top {\n    .recharts-legend-wrapper {\n      top: 0;\n      bottom: unset !important;\n    }\n  }\n\n  .recharts-legend-item {\n    margin-bottom: ",
        ";\n    margin-right: ",
        " !important;\n    display: flex !important;\n    align-items: center;\n  }\n\n  &.gender .recharts-legend-item {\n    display: inline-flex !important;\n  }\n\n  .recharts-legend-item-text {\n    color: ",
        " !important;\n    font-size: ",
        ";\n    text-align: left;\n  }\n\n  .recharts-default-tooltip {\n    background-color: ",
        " !important;\n    border: 0 !important;\n    border-radius: ",
        ";\n    padding: ",
        " !important;\n    font-size: ",
        ";\n    color: ",
        ";\n    font-weight: ",
        ";\n    position: relative;\n\n    &::before {\n      content: '';\n      width: 0;\n      height: 0;\n      position: absolute;\n    }\n  }\n\n  .recharts-tooltip-wrapper-bottom .recharts-default-tooltip.tooltip-y::before {\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-bottom: 6px solid ",
        ";\n    top: -5px;\n    left: 50%;\n    right: unset;\n    transform: translateX(-50%);\n  }\n\n  .recharts-tooltip-wrapper-top .recharts-default-tooltip.tooltip-y::before {\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-top: 6px solid ",
        ";\n    bottom: -5px;\n    left: 50%;\n    right: unset;\n    transform: translateX(-50%);\n  }\n\n  .recharts-tooltip-wrapper-left .recharts-default-tooltip.tooltip-x::before {\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-left: 6px solid ",
        ";\n    right: -5px;\n    left: unset;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .recharts-tooltip-wrapper-right .recharts-default-tooltip.tooltip-x::before {\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-right: 6px solid ",
        ";\n    left: -5px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .recharts-tooltip-item {\n    padding: 0 !important;\n    color: inherit !important;\n  }\n\n  .recharts-tooltip-item-name {\n    font-weight: ",
        ";\n  }\n\n  .recharts-default-legend {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  &.vertical-legend {\n    .recharts-default-legend {\n      flex-direction: column;\n    }\n  }\n\n  &.xAxisLabel {\n    .recharts-cartesian-axis-tick .recharts-text {\n      text-transform: initial;\n    }\n  }\n\n  &.treemap {\n    text {\n      fill: ",
        ";\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      stroke: none;\n      filter: drop-shadow(1px 1px 0px rgba(0, 0, 0, 0.3));\n    }\n  }\n"
    ]);
    Recharts_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledRecharts = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d4110a78-0"
})(Recharts_styled_templateObject(), (0,theme/* screen */.sp)("mdMax"), (0,theme/* radius */.q0)("sm"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontSize */.JB)("xs2"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* radius */.q0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/benefits/charts/SalaryByEnglishLevel.tsx






var SalaryByEnglishLevel = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 400,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineChart/* LineChart */.w, {
                    width: 500,
                    height: 300,
                    data: salary_by_english_level_namespaceObject,
                    margin: {
                        top: 45,
                        right: 35,
                        left: 20,
                        bottom: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            dataKey: function(data) {
                                return data.years[locale || "en"];
                            },
                            tickLine: false,
                            axisLine: true,
                            tickMargin: 5
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "number",
                            tickLine: false,
                            axisLine: true,
                            tickMargin: 10,
                            tickFormatter: function(tick) {
                                return "€".concat((Math.sign(tick) * (Math.abs(tick) / 1000)).toFixed(0), "K");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#d9ceff"
                            },
                            labelStyle: {
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                borderBottom: "1px solid #837e93",
                                marginBottom: "8px",
                                fontSize: "12px"
                            },
                            separator: ": ",
                            formatter: function(value) {
                                return "€".concat(value.toLocaleString(locale));
                            },
                            wrapperClassName: "tooltip-x"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                            layout: "horizontal",
                            iconType: "square",
                            wrapperStyle: {
                                top: 0
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            type: "monotone",
                            dataKey: "basic",
                            stroke: "#1B9D76",
                            name: t("mantechcar24.benefits.english.basic")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            type: "monotone",
                            dataKey: "intermediate",
                            stroke: "#D95F02",
                            name: t("mantechcar24.benefits.english.intermediate")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            type: "monotone",
                            dataKey: "fluent",
                            stroke: "#746FB3",
                            name: t("mantechcar24.benefits.english.fluent")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            type: "monotone",
                            dataKey: "native",
                            stroke: "#E7278A",
                            name: t("mantechcar24.benefits.english.native")
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_SalaryByEnglishLevel = (SalaryByEnglishLevel);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/benefits/Benefits.tsx










var Benefits = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    var averageSalaryByRoleAndExperienceTabs = AVERAGESALARYBYROLEANDEXPERIENCETABS(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionHero_SectionHero, {
                image: (0,paths/* getPublicPath */.A)("/images/stateSector/2024/benefits.png"),
                title: t("mantechcar24.benefits.hero.title"),
                desc: t("mantechcar24.benefits.hero.desc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar24.benefits.location.title"),
                desc: t("mantechcar24.benefits.location.desc"),
                descExtra: t("mantechcar24.benefits.location.text"),
                shareId: "locationpreference",
                emailSubject: t("mantechcar24.share-modal.location.email-subject"),
                emailMessage: t("mantechcar24.share-modal.location.email-text"),
                shareMessage: t("mantechcar24.share-modal.location.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_LocationPreference, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar24.benefits.average-salary-role.title"),
                desc: t("mantechcar24.benefits.average-salary-role.desc"),
                descExtra: t("mantechcar24.benefits.average-salary-role.descExtra"),
                shareId: "averagesalarybyroleandexperience",
                emailSubject: t("mantechcar24.share-modal.average-salary-role.email-subject"),
                emailMessage: t("mantechcar24.share-modal.average-salary-role.email-text"),
                shareMessage: t("mantechcar24.share-modal.average-salary-role.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(switcher_Switcher, {
                    tabsName: averageSalaryByRoleAndExperienceTabs.tabsName,
                    tabs: averageSalaryByRoleAndExperienceTabs.tabs,
                    label: averageSalaryByRoleAndExperienceTabs.label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar24.benefits.english.title"),
                desc: t("mantechcar24.benefits.english.desc"),
                descExtra: t("mantechcar24.benefits.english.descExtra"),
                shareId: "salarybyenglishlevel",
                emailSubject: t("mantechcar24.share-modal.english.email-subject"),
                emailMessage: t("mantechcar24.share-modal.english.email-text"),
                shareMessage: t("mantechcar24.share-modal.english.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_SalaryByEnglishLevel, {})
            })
        ]
    });
};
/* harmony default export */ var benefits_Benefits = (Benefits);

;// CONCATENATED MODULE: ./data/mantechcar24/location-offered.json
var location_offered_namespaceObject = JSON.parse('[{"year":"2021","remote":86.1878453038674,"hybrid":11.049723756906078,"onsite":2.7624309392265194},{"year":"2022","remote":88.91509433962264,"hybrid":9.90566037735849,"onsite":1.179245283018868},{"year":"2023","remote":80.16528925619835,"hybrid":18.732782369146005,"onsite":1.1019283746556474},{"year":"2024","remote":69.29133858267717,"hybrid":25.984251968503933,"onsite":4.724409448818897}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/companies/charts/LocationOffered.tsx





var LocationOffered = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 400,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineChart/* LineChart */.w, {
                    width: 500,
                    height: 300,
                    data: location_offered_namespaceObject,
                    margin: {
                        top: 35,
                        right: 30,
                        left: 20,
                        bottom: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            dataKey: "year",
                            type: "category",
                            tickLine: false,
                            tickMargin: 10
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            domain: [
                                0,
                                100
                            ],
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            },
                            tickLine: false,
                            tickMargin: 5
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            labelStyle: {
                                borderBottom: "1px solid #4d485c",
                                marginBottom: "6px",
                                fontWeight: 900
                            },
                            formatter: function(value) {
                                return value.toFixed(1) + "%";
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                            layout: "horizontal",
                            iconType: "square",
                            wrapperStyle: {
                                top: 0
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            type: "linear",
                            dataKey: "onsite",
                            stroke: "#1B9D76",
                            name: t("mantechcar24.companies.locations-offered.onsite")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            type: "linear",
                            dataKey: "remote",
                            stroke: "#D95F02",
                            name: t("mantechcar24.companies.locations-offered.remote")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            type: "linear",
                            dataKey: "hybrid",
                            stroke: "#746FB3",
                            name: t("mantechcar24.companies.locations-offered.hybrid")
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_LocationOffered = (LocationOffered);

;// CONCATENATED MODULE: ./data/mantechcar24/most-offered-perks.json
var most_offered_perks_namespaceObject = JSON.parse('[{"year":"2022","Dinámicas y eventos de teambuilding":1,"Presupuesto para formación":2,"Eventos de formación internos":3,"Posibilidad de elegir equipo":7,"Seguro de salud":4,"Presupuesto para conferencias":6,"Clases de idiomas":5,"Pack de bienvenida":9,"Vacaciones extra":8,"Café":11,"Fruta y snacks":10},{"year":"2023","Dinámicas y eventos de teambuilding":1,"Presupuesto para formación":2,"Eventos de formación internos":3,"Posibilidad de elegir equipo":4,"Seguro de salud":5,"Presupuesto para conferencias":11,"Clases de idiomas":6,"Pack de bienvenida":7,"Vacaciones extra":10,"Café":9,"Fruta y snacks":8},{"year":"2024","Dinámicas y eventos de teambuilding":1,"Presupuesto para formación":2,"Eventos de formación internos":3,"Posibilidad de elegir equipo":4,"Seguro de salud":5,"Presupuesto para conferencias":6,"Clases de idiomas":7,"Pack de bienvenida":8,"Vacaciones extra":9,"Café":10,"Fruta y snacks":11}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/companies/charts/MostOfferedPerks.tsx






var MostOfferedPerks = function() {
    var keyToSlug = function keyToSlug(key) {
        return key.toLowerCase().replace(/ /g, "-").replace(/[^\w-]+/g, "");
    };
    var getPositionOfKey = function getPositionOfKey(data, key) {
        return data[key];
    };
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    var keysFromData = (0,_to_consumable_array/* default */.Z)(new Set(most_offered_perks_namespaceObject.flatMap(function(obj) {
        return Object.keys(obj);
    }))).filter(function(key) {
        return key !== "year";
    });
    var colors = [
        "#BDB9DA",
        "#8DD3C7",
        "#FB8274",
        "#7EAFD3",
        "#FDB563",
        "#B3DE68",
        "#666666",
        "#BC7FBD",
        "#CDEBC6",
        "#FFEE70",
        "#FFA07A",
        "#FF82A9",
        "#FFB7B2",
        "#FFD3B5",
        "#FF3E4E",
        "#FF6F61",
        "#FF9B85",
        "#FFC1A"
    ];
    var CustomTickLabelLeft = Object.keys(most_offered_perks_namespaceObject[0]).filter(function(key) {
        return key !== "year";
    }).sort(function(a, b) {
        return getPositionOfKey(most_offered_perks_namespaceObject[0], a) - getPositionOfKey(most_offered_perks_namespaceObject[0], b);
    }).map(function(key) {
        return t("mantechcar24.companies.most-offered-perks.".concat(keyToSlug(key)));
    });
    var CustomTickLeft = function(param) {
        var x = param.x, y = param.y, payload = param.payload;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "translate(".concat(x, ",").concat(y, ")"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                x: 0,
                y: 0,
                dy: 5,
                textAnchor: "end",
                fontSize: 16,
                fill: "#353241",
                stroke: "#353241",
                strokeOpacity: "0.2",
                children: CustomTickLabelLeft[payload.value - 1]
            })
        });
    };
    var CustomTickLabelRight = Object.keys(most_offered_perks_namespaceObject[most_offered_perks_namespaceObject.length - 1]).filter(function(key) {
        return key !== "year";
    }).sort(function(a, b) {
        return getPositionOfKey(most_offered_perks_namespaceObject[most_offered_perks_namespaceObject.length - 1], a) - getPositionOfKey(most_offered_perks_namespaceObject[most_offered_perks_namespaceObject.length - 1], b);
    }).map(function(key) {
        return t("mantechcar24.companies.most-offered-perks.".concat(keyToSlug(key)));
    });
    var CustomTickRight = function(param) {
        var x = param.x, y = param.y, payload = param.payload;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "translate(".concat(x, ",").concat(y, ")"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                x: 0,
                y: 0,
                dy: 5,
                textAnchor: "start",
                fontSize: 16,
                fill: "#353241",
                stroke: "#353241",
                strokeOpacity: "0.2",
                children: CustomTickLabelRight[payload.value - 1]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 500,
                width: "99%",
                minWidth: 750,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineChart/* LineChart */.w, {
                    width: 500,
                    height: 300,
                    data: most_offered_perks_namespaceObject,
                    margin: {
                        top: 20,
                        right: 250,
                        left: 250,
                        bottom: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            dataKey: "year",
                            padding: {
                                left: 20,
                                right: 20
                            },
                            axisLine: false,
                            tickLine: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            yAxisId: "left",
                            domain: [
                                1,
                                keysFromData.length
                            ],
                            interval: 0,
                            tickCount: keysFromData.length,
                            reversed: true,
                            tick: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTickLeft, {}),
                            axisLine: false,
                            tickLine: false,
                            padding: {
                                bottom: 20
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            yAxisId: "right",
                            orientation: "right",
                            domain: [
                                1,
                                keysFromData.length
                            ],
                            interval: 0,
                            tickCount: keysFromData.length,
                            reversed: true,
                            tick: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTickRight, {}),
                            axisLine: false,
                            tickLine: false,
                            padding: {
                                bottom: 20
                            }
                        }),
                        keysFromData.map(function(key, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                type: "linear",
                                yAxisId: "left",
                                dataKey: key,
                                stroke: colors[index],
                                strokeWidth: 4,
                                dot: {
                                    stroke: "#A29EAE",
                                    strokeWidth: 1,
                                    r: 4
                                }
                            }, key);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            type: "linear",
                            yAxisId: "right",
                            hide: true
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MostOfferedPerks = (MostOfferedPerks);

;// CONCATENATED MODULE: ./data/mantechcar24/most-wanted-roles.json
var most_wanted_roles_namespaceObject = JSON.parse('[{"year":"2022","Backend Developer":1,"Full-Stack Developer":7,"Frontend Developer":2,"DevOps & Infrastructure & SRE":3,"Tech Lead":9,"Mobile Developer":4,"Project Manager & Delivery Manager":13,"Data Engineer":5,"SysAdmin":12,"Product Manager":8,"Product Owner":11,"Software Architect":14,"QA & Testing":6,"Engineering Management":10,"Graphic & Motion Design":16,"Pre-Sales Engineer":15},{"year":"2023","Backend Developer":1,"Full-Stack Developer":3,"Frontend Developer":2,"DevOps & Infrastructure & SRE":4,"Tech Lead":5,"Mobile Developer":6,"Project Manager & Delivery Manager":11,"Data Engineer":9,"SysAdmin":7,"Product Manager":13,"Product Owner":14,"Software Architect":8,"QA & Testing":10,"Engineering Management":12,"Graphic & Motion Design":15,"Pre-Sales Engineer":16},{"year":"2024","Backend Developer":1,"Full-Stack Developer":2,"Frontend Developer":3,"DevOps & Infrastructure & SRE":4,"Tech Lead":5,"Mobile Developer":6,"Project Manager & Delivery Manager":7,"Data Engineer":8,"SysAdmin":9,"Product Manager":10,"Product Owner":11,"Software Architect":12,"QA & Testing":13,"Engineering Management":14,"Graphic & Motion Design":15,"Pre-Sales Engineer":16}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/companies/charts/MostWantedRoles.tsx





var MostWantedRoles = function() {
    var getPositionOfKey = function getPositionOfKey(data, key) {
        return data[key];
    };
    var keysFromData = (0,_to_consumable_array/* default */.Z)(new Set(most_wanted_roles_namespaceObject.flatMap(function(obj) {
        return Object.keys(obj);
    }))).filter(function(key) {
        return key !== "year";
    });
    var colors = [
        "#BDB9DA",
        "#8DD3C7",
        "#FB8274",
        "#7EAFD3",
        "#FDB563",
        "#B3DE68",
        "#666666",
        "#BC7FBD",
        "#CDEBC6",
        "#FFEE70",
        "#FFA07A",
        "#FF82A9",
        "#FFB7B2",
        "#FFD3B5",
        "#FF3E4E",
        "#FF6F61",
        "#FF9B85",
        "#FFC1A"
    ];
    var CustomTickLabelLeft = Object.keys(most_wanted_roles_namespaceObject[0]).filter(function(key) {
        return key !== "year";
    }).sort(function(a, b) {
        return getPositionOfKey(most_wanted_roles_namespaceObject[0], a) - getPositionOfKey(most_wanted_roles_namespaceObject[0], b);
    });
    var CustomTickLeft = function(param) {
        var x = param.x, y = param.y, payload = param.payload;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "translate(".concat(x, ",").concat(y, ")"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                x: 0,
                y: 0,
                dy: 5,
                textAnchor: "end",
                fontSize: 16,
                fill: "#353241",
                stroke: "#353241",
                strokeOpacity: "0.2",
                children: CustomTickLabelLeft[payload.value - 1]
            })
        });
    };
    var CustomTickLabelRight = Object.keys(most_wanted_roles_namespaceObject[most_wanted_roles_namespaceObject.length - 1]).filter(function(key) {
        return key !== "year";
    }).sort(function(a, b) {
        return getPositionOfKey(most_wanted_roles_namespaceObject[most_wanted_roles_namespaceObject.length - 1], a) - getPositionOfKey(most_wanted_roles_namespaceObject[most_wanted_roles_namespaceObject.length - 1], b);
    });
    var CustomTickRight = function(param) {
        var x = param.x, y = param.y, payload = param.payload;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "translate(".concat(x, ",").concat(y, ")"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                x: 0,
                y: 0,
                dy: 5,
                textAnchor: "start",
                fontSize: 16,
                fill: "#353241",
                stroke: "#353241",
                strokeOpacity: "0.2",
                children: CustomTickLabelRight[payload.value - 1]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 500,
                width: "99%",
                minWidth: 750,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineChart/* LineChart */.w, {
                    width: 500,
                    height: 300,
                    data: most_wanted_roles_namespaceObject,
                    margin: {
                        top: 20,
                        right: 250,
                        left: 250,
                        bottom: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            dataKey: "year",
                            padding: {
                                left: 20,
                                right: 20
                            },
                            axisLine: false,
                            tickLine: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            yAxisId: "left",
                            domain: [
                                1,
                                keysFromData.length
                            ],
                            interval: 0,
                            tickCount: keysFromData.length,
                            reversed: true,
                            tick: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTickLeft, {}),
                            axisLine: false,
                            tickLine: false,
                            padding: {
                                bottom: 20
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            yAxisId: "right",
                            orientation: "right",
                            domain: [
                                1,
                                keysFromData.length
                            ],
                            interval: 0,
                            tickCount: keysFromData.length,
                            reversed: true,
                            tick: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTickRight, {}),
                            axisLine: false,
                            tickLine: false,
                            padding: {
                                bottom: 20
                            }
                        }),
                        keysFromData.map(function(key, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                type: "linear",
                                yAxisId: "left",
                                dataKey: key,
                                stroke: colors[index],
                                strokeWidth: 4,
                                dot: {
                                    stroke: "#A29EAE",
                                    strokeWidth: 1,
                                    r: 4
                                }
                            }, key);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            type: "linear",
                            yAxisId: "right",
                            hide: true
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MostWantedRoles = (MostWantedRoles);

;// CONCATENATED MODULE: ./data/mantechcar24/salary-offered-vs-wanted.json
var salary_offered_vs_wanted_namespaceObject = JSON.parse('[{"role":"Engineering Management","desired":68386,"offered":60467},{"role":"Software Architect","desired":61631,"offered":49431},{"role":"Tech Lead","desired":55255,"offered":54589},{"role":"DevOps & Infrastructure & SRE","desired":51550,"offered":47211},{"role":"Project Manager & Delivery Manager","desired":51177,"offered":42917},{"role":"Product Manager","desired":47234,"offered":49113},{"role":"Data Engineer","desired":46156,"offered":47386},{"role":"Mobile Developer","desired":45447,"offered":46077},{"role":"Scrum Master & Agile Coach","desired":43667,"offered":40000},{"role":"Data Scientist","desired":43375,"offered":49265},{"role":"Backend Developer","desired":43063,"offered":43352},{"role":"QA & Testing","desired":42701,"offered":37321},{"role":"Full-Stack Developer","desired":41428,"offered":42592},{"role":"Machine Learning Engineer","desired":40887,"offered":60312},{"role":"Data Analyst & BI","desired":39517,"offered":45711},{"role":"Frontend Developer","desired":38684,"offered":41536},{"role":"SysAdmin","desired":36689,"offered":34114},{"role":"Product Design (UI/UX)","desired":36138,"offered":38568}]');
// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/BarChart.js
var BarChart = __webpack_require__(80739);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/Bar.js
var Bar = __webpack_require__(24908);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/companies/charts/SalaryOfferedVsWanted.tsx






var SalaryOfferedVsWanted = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "xAxisLabel",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: "99%",
                height: 950,
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: salary_offered_vs_wanted_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick / 1000, "K");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "role",
                            tickLine: false,
                            width: 200
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#ebe8df"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: ": ",
                            formatter: function(value) {
                                return "€".concat(value.toLocaleString(locale));
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                            layout: "horizontal",
                            iconType: "square",
                            wrapperStyle: {
                                bottom: 0
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "offered",
                            name: t("mantechcar24.companies.salary-offered-wanted.offered"),
                            fill: "#7EAFD3",
                            barSize: 8,
                            radius: 5
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "desired",
                            name: t("mantechcar24.companies.salary-offered-wanted.desired"),
                            fill: "#8DD3C7",
                            barSize: 8,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_SalaryOfferedVsWanted = (SalaryOfferedVsWanted);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/companies/Companies.styled.tsx

function Companies_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    background-color: ",
        ";\n  }\n\n  ",
        " ",
        "::before {\n    background-color: ",
        ";\n  }\n"
    ]);
    Companies_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Companies_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5c12abc1-0"
})(Companies_styled_templateObject(), StyledHero, (0,theme/* color */.$_)("purple_100"), StyledContainer, Typography_styled/* Heading2 */.XJ, (0,theme/* color */.$_)("purple_500"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/companies/Companies.tsx










var Companies = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Companies_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionHero_SectionHero, {
                image: (0,paths/* getPublicPath */.A)("/images/stateSector/2024/companies.png"),
                title: t("mantechcar24.companies.hero.title"),
                desc: t("mantechcar24.companies.hero.desc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar24.companies.salary-offered-wanted.title"),
                desc: t("mantechcar24.companies.salary-offered-wanted.desc"),
                descExtra: t("mantechcar24.companies.salary-offered-wanted.descExtra"),
                shareId: "salaryofferedvswanted",
                emailSubject: t("mantechcar24.share-modal.salary-offered-wanted.email-subject"),
                emailMessage: t("mantechcar24.share-modal.salary-offered-wanted.email-text"),
                shareMessage: t("mantechcar24.share-modal.salary-offered-wanted.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_SalaryOfferedVsWanted, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar24.companies.most-wanted-roles.title"),
                desc: t("mantechcar24.companies.most-wanted-roles.desc"),
                descExtra: t("mantechcar24.companies.most-wanted-roles.descExtra"),
                shareId: "mostwantedroles",
                emailSubject: t("mantechcar24.share-modal.most-wanted-roles.email-subject"),
                emailMessage: t("mantechcar24.share-modal.most-wanted-roles.email-text"),
                shareMessage: t("mantechcar24.share-modal.most-wanted-roles.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostWantedRoles, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar24.companies.most-offered-perks.title"),
                desc: t("mantechcar24.companies.most-offered-perks.desc"),
                descExtra: t("mantechcar24.companies.most-offered-perks.descExtra"),
                shareId: "mostofferedperks",
                emailSubject: t("mantechcar24.share-modal.most-offered-perks.email-subject"),
                emailMessage: t("mantechcar24.share-modal.most-offered-perks.email-text"),
                shareMessage: t("mantechcar24.share-modal.most-offered-perks.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostOfferedPerks, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar24.companies.locations-offered.title"),
                desc: t("mantechcar24.companies.locations-offered.desc"),
                shareId: "locationoffered",
                emailSubject: t("mantechcar24.share-modal.locations-offered.email-subject"),
                emailMessage: t("mantechcar24.share-modal.locations-offered.email-text"),
                shareMessage: t("mantechcar24.share-modal.locations-offered.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_LocationOffered, {})
            })
        ]
    });
};
/* harmony default export */ var companies_Companies = (Companies);

;// CONCATENATED MODULE: ./data/mantechcar24/female-representation-by-role.json
var female_representation_by_role_namespaceObject = JSON.parse('{"nodes":[{"name":"Total","fill":"#17BECF"},{"name":"Backend","fill":"#2CA02C"},{"name":"Frontend","fill":"#D62728"},{"name":"Tech Lead","fill":"#9467BD"},{"name":"Software","fill":"#8C564B"},{"name":"Data","fill":"#E377C2"},{"name":"Diseño","fill":"#17BECF"},{"name":"Marketing","fill":"#2CA02C"},{"name":"Producto","fill":"#D62728"},{"name":"Otros","fill":"#9467BD"}],"links":[{"source":0,"target":1,"value":2445},{"source":0,"target":2,"value":2458},{"source":0,"target":3,"value":791},{"source":0,"target":4,"value":1164},{"source":0,"target":5,"value":1204},{"source":0,"target":6,"value":1177},{"source":0,"target":7,"value":613},{"source":0,"target":8,"value":1628},{"source":0,"target":9,"value":5131}]}');
// EXTERNAL MODULE: ../../node_modules/recharts/es6/container/Layer.js
var Layer = __webpack_require__(84618);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/shape/Rectangle.js
var Rectangle = __webpack_require__(43624);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/Sankey.js
var Sankey = __webpack_require__(28776);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/gender/charts/FemaleByRole.tsx






var FemalesByRole = function() {
    var locale = (0,router.useRouter)().locale;
    var CustomNode = function(param) {
        var x = param.x, y = param.y, height = param.height, index = param.index, payload = param.payload;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layer/* Layer */.m, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Rectangle/* Rectangle */.A, {
                    x: x,
                    y: y,
                    width: 20,
                    height: height,
                    fill: payload.fill,
                    fillOpacity: "1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                    textAnchor: "start",
                    x: x + 26,
                    y: y + height / 2,
                    fontSize: "14",
                    fill: "#837E93",
                    children: payload.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                    textAnchor: "start",
                    x: x + 26,
                    y: y + height / 2 + 14,
                    fontSize: "12",
                    stroke: "#1F1D26",
                    strokeOpacity: "0.5",
                    children: payload.value.toLocaleString(locale)
                })
            ]
        }, "CustomNode".concat(index));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 600,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Sankey/* Sankey */.b, {
                    data: female_representation_by_role_namespaceObject,
                    node: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomNode, {}),
                    nodePadding: 30,
                    margin: {
                        top: 10,
                        right: 200,
                        bottom: 50
                    },
                    link: {
                        stroke: "#17BECF"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {})
                })
            })
        })
    });
};
/* harmony default export */ var FemaleByRole = (FemalesByRole);

;// CONCATENATED MODULE: ./data/mantechcar24/female-representation-vs-male-by-role.json
var female_representation_vs_male_by_role_namespaceObject = JSON.parse('{"nodes":[{"name":"Femenino","fill":"#17BECF"},{"name":"Masculino","fill":"#17BECF"},{"name":"Backend","fill":"#2CA02C"},{"name":"Frontend","fill":"#D62728"},{"name":"Tech Lead","fill":"#9467BD"},{"name":"Software","fill":"#8C564B"},{"name":"Data","fill":"#E377C2"},{"name":"Diseño","fill":"#17BECF"},{"name":"Marketing","fill":"#17BECF"},{"name":"Producto","fill":"#2CA02C"},{"name":"Otros","fill":"#D62728"}],"links":[{"source":0,"target":2,"value":2445},{"source":1,"target":2,"value":20966},{"source":0,"target":3,"value":2458},{"source":1,"target":3,"value":9873},{"source":0,"target":4,"value":791},{"source":1,"target":4,"value":10129},{"source":0,"target":5,"value":1164},{"source":1,"target":5,"value":7815},{"source":0,"target":6,"value":1204},{"source":1,"target":6,"value":4790},{"source":0,"target":7,"value":1177},{"source":1,"target":7,"value":1207},{"source":0,"target":8,"value":613},{"source":1,"target":8,"value":649},{"source":0,"target":9,"value":1628},{"source":1,"target":9,"value":3413},{"source":0,"target":10,"value":5131},{"source":1,"target":10,"value":18693}]}');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/gender/charts/FemalesVsMalesByRole.tsx







var FemalesVsMalesByRole = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    var locale = (0,router.useRouter)().locale;
    var CustomNode = function(param) {
        var x = param.x, y = param.y, height = param.height, index = param.index, payload = param.payload;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layer/* Layer */.m, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Rectangle/* Rectangle */.A, {
                    x: x,
                    y: y,
                    width: 20,
                    height: height,
                    fill: payload.fill,
                    fillOpacity: "1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                    textAnchor: "start",
                    x: x + 26,
                    y: y + height / 2,
                    fontSize: "14",
                    fill: "#837E93",
                    children: t(payload.name)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                    textAnchor: "start",
                    x: x + 26,
                    y: y + height / 2 + 14,
                    fontSize: "12",
                    stroke: "#1F1D26",
                    strokeOpacity: "0.5",
                    children: payload.value.toLocaleString(locale)
                })
            ]
        }, "CustomNode".concat(index));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 600,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Sankey/* Sankey */.b, {
                    data: female_representation_vs_male_by_role_namespaceObject,
                    node: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomNode, {}),
                    nodePadding: 25,
                    margin: {
                        top: 10,
                        right: 200,
                        bottom: 50
                    },
                    link: {
                        stroke: "#17BECF"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {})
                })
            })
        })
    });
};
/* harmony default export */ var charts_FemalesVsMalesByRole = (FemalesVsMalesByRole);

;// CONCATENATED MODULE: ./data/mantechcar24/gender-comparison-by-role.json
var gender_comparison_by_role_namespaceObject = JSON.parse('[{"role":"Backend Developer","female":9,"male":91},{"role":"Data Analyst & BI","female":23,"male":77},{"role":"Data Engineer","female":12,"male":88},{"role":"Data Scientist","female":17,"male":83},{"role":"DevOps & Infrastructure & SRE","female":7,"male":93},{"role":"Engineering Management","female":7,"male":93},{"role":"Frontend Developer","female":16,"male":84},{"role":"Full-Stack Developer","female":11,"male":89},{"role":"Mobile Developer","female":9,"male":91},{"role":"Product Design (UI/UX)","female":46,"male":54},{"role":"Product Manager","female":27,"male":73},{"role":"Project Manager & Delivery Manager","female":27,"male":73},{"role":"QA & Testing","female":26,"male":74},{"role":"Software Architect","female":6,"male":94},{"role":"SysAdmin","female":6,"male":94},{"role":"Tech Lead","female":5,"male":95}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/gender/charts/GenderComparison.tsx






var GenderComparison = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    var genderByRole = gender_comparison_by_role_namespaceObject.sort(function(a, b) {
        return a.female > b.female ? -1 : 1;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "gender gender-by-role",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 550,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: genderByRole,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            hide: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "role",
                            tickLine: false,
                            width: 210,
                            axisLine: false,
                            tickMargin: 10
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "transparent"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: ": ",
                            formatter: function(value) {
                                return value.toFixed(1) + "%";
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                            layout: "horizontal",
                            iconType: "square",
                            wrapperStyle: {
                                bottom: -5
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "female",
                            stackId: "a",
                            name: t("mantechcar24.gender.females"),
                            barSize: 12,
                            radius: 5,
                            fill: "#974EA2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "male",
                            stackId: "a",
                            name: t("mantechcar24.gender.males"),
                            barSize: 12,
                            radius: 5,
                            fill: "#7EAFD3"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_GenderComparison = (GenderComparison);

;// CONCATENATED MODULE: ./data/mantechcar24/gender-salary-by-experience.json
var gender_salary_by_experience_namespaceObject = JSON.parse('[{"exp":"<2y","male":30663,"female":29196},{"exp":"2-5y","male":41286,"female":37849},{"exp":"5-10y","male":54106,"female":48354},{"exp":">10y","male":60194,"female":51277}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/gender/charts/GenderSalaryByExperience.tsx







var GenderSalaryByExperience = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "gender",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 300,
                width: "99%",
                minWidth: 700,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: gender_salary_by_experience_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "exp",
                            tickLine: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick / 1000, "K");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#d9ceff"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: ": ",
                            formatter: function(value) {
                                return "".concat(value.toLocaleString(locale), "€");
                            },
                            wrapperClassName: "tooltip-x"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                            layout: "horizontal",
                            iconType: "square",
                            wrapperStyle: {
                                bottom: -5
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "female",
                            name: t("mantechcar24.gender.females"),
                            barSize: 8,
                            radius: 5,
                            fill: "#974EA2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "male",
                            name: t("mantechcar24.gender.males"),
                            barSize: 8,
                            radius: 5,
                            fill: "#7EAFD3"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_GenderSalaryByExperience = (GenderSalaryByExperience);

;// CONCATENATED MODULE: ./data/mantechcar24/gender-salary-by-role.json
var gender_salary_by_role_namespaceObject = JSON.parse('[{"role":"Backend Developer","female":38051,"male":43672},{"role":"Data Analyst & BI","female":38562,"male":39662},{"role":"Data Engineer","female":41379,"male":46604},{"role":"Data Scientist","female":40660,"male":44048},{"role":"DevOps & Infrastructure & SRE","female":47114,"male":52052},{"role":"Engineering Management","female":59089,"male":69209},{"role":"Frontend Developer","female":33867,"male":39578},{"role":"Full-Stack Developer","female":35171,"male":42229},{"role":"Mobile Developer","female":41157,"male":45948},{"role":"Product Design (UI/UX)","female":31925,"male":39323},{"role":"Product Manager","female":41968,"male":49097},{"role":"Project Manager & Delivery Manager","female":46822,"male":52742},{"role":"QA & Testing","female":40913,"male":43388},{"role":"Software Architect","female":61339,"male":61876},{"role":"SysAdmin","female":35043,"male":36875},{"role":"Tech Lead","female":51034,"male":55342}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/gender/charts/GenderSalaryByRole.tsx







var GenderSalaryByRole = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    var locale = (0,router.useRouter)().locale;
    var genderSalaryByRole = gender_salary_by_role_namespaceObject.sort(function(a, b) {
        return a.female > b.female ? -1 : 1;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "gender xAxisLabel",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 750,
                width: "99%",
                minWidth: 700,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: genderSalaryByRole,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick / 1000, "K");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "role",
                            tickLine: false,
                            width: 200
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#d9ceff"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: ": ",
                            formatter: function(value) {
                                return "".concat(value.toLocaleString(locale), "€");
                            },
                            wrapperClassName: "tooltip-x"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                            layout: "horizontal",
                            iconType: "square",
                            wrapperStyle: {
                                bottom: -5
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "female",
                            name: t("mantechcar24.gender.females"),
                            barSize: 12,
                            radius: 5,
                            fill: "#974EA2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "male",
                            name: t("mantechcar24.gender.males"),
                            barSize: 12,
                            radius: 5,
                            fill: "#7EAFD3"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_GenderSalaryByRole = (GenderSalaryByRole);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/gender/Gender.styled.tsx

function Gender_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    background-color: ",
        ";\n  }\n\n  ",
        " ",
        "::before {\n    background-color: ",
        ";\n  }\n"
    ]);
    Gender_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Gender_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n"
    ]);
    Gender_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Gender_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66cc0a44-0"
})(Gender_styled_templateObject(), StyledHero, (0,theme/* color */.$_)("indigo_100"), StyledContainer, Typography_styled/* Heading2 */.XJ, (0,theme/* color */.$_)("indigo_500"));
var StyledSubsectionTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography_styled/* Heading3 */.aC).withConfig({
    componentId: "sc-66cc0a44-1"
})(Gender_styled_templateObject1(), (0,theme/* fontFamily */.I8)("sans"));

// EXTERNAL MODULE: ./components/shared/CustomSelect.tsx + 1 modules
var CustomSelect = __webpack_require__(88888);
// EXTERNAL MODULE: ./components/shared/FormGroup.tsx
var FormGroup = __webpack_require__(74993);
;// CONCATENATED MODULE: ./data/mantechcar24/gender-salary-by-role-and-experience.json
var gender_salary_by_role_and_experience_namespaceObject = JSON.parse('[{"role":"Account Manager","tier1":{"male":33429,"female":28667},"tier2":{"male":37585,"female":29677},"tier3":{"male":45342,"female":37739},"tier4":{"male":52100,"female":37667}},{"role":"Accounting & Financial Planning","tier1":{"male":32950,"female":28647},"tier2":{"male":37775,"female":37632},"tier3":{"male":52625,"female":43600},"tier4":{"male":57938,"female":47769}},{"role":"Accounts & Payroll","tier1":{"male":22625,"female":25400},"tier2":{"male":43600,"female":24300},"tier3":{"male":27833,"female":27375},"tier4":{"male":52667,"female":21000}},{"role":"Administration","tier1":{"male":28551,"female":27683},"tier2":{"male":35527,"female":26925},"tier3":{"male":31896,"female":33269},"tier4":{"male":35395,"female":28417}},{"role":"Backend Developer","tier1":{"male":28246,"female":27591},"tier2":{"male":39491,"female":38495},"tier3":{"male":52343,"female":50326},"tier4":{"male":56700,"female":51304}},{"role":"Brand & Creative Marketing","tier1":{"male":28120,"female":24959},"tier2":{"male":29918,"female":27615},"tier3":{"male":34783,"female":33673},"tier4":{"male":41348,"female":41839}},{"role":"Brand Design","tier1":{"male":26085,"female":23283},"tier2":{"male":26364,"female":25182},"tier3":{"male":32436,"female":31562},"tier4":{"male":37709,"female":33565}},{"role":"Business Operations & Strategy","tier1":{"male":34025,"female":31762},"tier2":{"male":44447,"female":40932},"tier3":{"male":53512,"female":47240},"tier4":{"male":63807,"female":59140}},{"role":"Content Marketing & Design","tier1":{"male":27145,"female":25732},"tier2":{"male":37849,"female":28695},"tier3":{"male":43107,"female":33757},"tier4":{"male":36906,"female":44148}},{"role":"Copywriter","tier1":{"male":24153,"female":23867},"tier2":{"male":35130,"female":27757},"tier3":{"male":39900,"female":32773},"tier4":{"male":32897,"female":30200}},{"role":"Corporate & Strategic Finance","tier1":{"male":34913,"female":33250},"tier2":{"male":44345,"female":38538},"tier3":{"male":55348,"female":47385},"tier4":{"male":58571,"female":66000}},{"role":"Customer Service & Support","tier1":{"male":28914,"female":25071},"tier2":{"male":31658,"female":31600},"tier3":{"male":37476,"female":38080},"tier4":{"male":41298,"female":38061}},{"role":"Customer Success & Account Management","tier1":{"male":31429,"female":28842},"tier2":{"male":37341,"female":29800},"tier3":{"male":47673,"female":40143},"tier4":{"male":51299,"female":43125}},{"role":"DBA","tier1":{"male":27010,"female":24000},"tier2":{"male":34486,"female":26286},"tier3":{"male":39931,"female":28000},"tier4":{"male":46625,"female":38250}},{"role":"Data Analyst & BI","tier1":{"male":29340,"female":27879},"tier2":{"male":39228,"female":39065},"tier3":{"male":46542,"female":48667},"tier4":{"male":53049,"female":49946}},{"role":"Data Engineer","tier1":{"male":32818,"female":30723},"tier2":{"male":43765,"female":41903},"tier3":{"male":56346,"female":52062},"tier4":{"male":61162,"female":51615}},{"role":"Data Scientist","tier1":{"male":32728,"female":33209},"tier2":{"male":44822,"female":44232},"tier3":{"male":56517,"female":50875},"tier4":{"male":59568,"female":48462}},{"role":"DevOps & Infrastructure & SRE","tier1":{"male":33346,"female":33106},"tier2":{"male":45188,"female":45541},"tier3":{"male":58460,"female":55930},"tier4":{"male":61621,"female":57500}},{"role":"Developer Advocate & Evangelist","tier1":{"male":27000,"female":25200},"tier2":{"male":44826,"female":35143},"tier3":{"male":53083,"female":48500},"tier4":{"male":60086,"female":49333}},{"role":"Director / General Manager","tier1":{"male":54471,"female":30571},"tier2":{"male":55288,"female":47125},"tier3":{"male":64204,"female":58560},"tier4":{"male":77527,"female":74000}},{"role":"Engineering Management","tier1":{"male":49679,"female":42333},"tier2":{"male":53915,"female":45533},"tier3":{"male":67720,"female":61925},"tier4":{"male":75161,"female":65216}},{"role":"Enterprise Sales","tier1":{"male":35556,"female":43000},"tier2":{"male":42133,"female":23667},"tier3":{"male":46111,"female":36333},"tier4":{"male":60536,"female":44111}},{"role":"Executive Assistant","tier1":{"male":34500,"female":36154},"tier2":{"male":47312,"female":25941},"tier3":{"male":35875,"female":23375},"tier4":{"male":60909,"female":52200}},{"role":"Finance Operations","tier1":{"male":36459,"female":33000},"tier2":{"male":45476,"female":47900},"tier3":{"male":52833,"female":56667},"tier4":{"male":58538,"female":107556}},{"role":"Frontend Developer","tier1":{"male":28524,"female":28040},"tier2":{"male":37919,"female":37063},"tier3":{"male":51936,"female":48006},"tier4":{"male":52886,"female":48152}},{"role":"Full-Stack Developer","tier1":{"male":28576,"female":26489},"tier2":{"male":39387,"female":38117},"tier3":{"male":51576,"female":49059},"tier4":{"male":56164,"female":52543}},{"role":"Generalist Marketing","tier1":{"male":25676,"female":24059},"tier2":{"male":29721,"female":27875},"tier3":{"male":39807,"female":33882},"tier4":{"male":46566,"female":42947}},{"role":"Generalist Recruitment","tier1":{"male":21870,"female":24289},"tier2":{"male":31037,"female":23945},"tier3":{"male":31727,"female":29675},"tier4":{"male":35263,"female":30158}},{"role":"Graphic & Motion Design","tier1":{"male":26508,"female":22939},"tier2":{"male":32059,"female":25451},"tier3":{"male":33038,"female":29912},"tier4":{"male":36563,"female":35100}},{"role":"Growth Manager","tier1":{"male":41067,"female":28167},"tier2":{"male":36275,"female":30412},"tier3":{"male":48961,"female":41000},"tier4":{"male":58952,"female":56385}},{"role":"Hardware Engineer","tier1":{"male":29951,"female":27571},"tier2":{"male":33340,"female":41000},"tier3":{"male":41825,"female":25000},"tier4":{"male":42481,"female":40667}},{"role":"Human Resources","tier1":{"male":24396,"female":24421},"tier2":{"male":32069,"female":25268},"tier3":{"male":40909,"female":29268},"tier4":{"male":50406,"female":40867}},{"role":"IT Manager","tier1":{"male":27747,"female":25300},"tier2":{"male":39687,"female":36467},"tier3":{"male":49211,"female":55158},"tier4":{"male":58510,"female":53273}},{"role":"Implementation & Solutions Engineer","tier1":{"male":32189,"female":50333},"tier2":{"male":40253,"female":40318},"tier3":{"male":50217,"female":47556},"tier4":{"male":58073,"female":51000}},{"role":"Layout Designer","tier1":{"male":24144,"female":22857},"tier2":{"male":28664,"female":25889},"tier3":{"male":35566,"female":29600},"tier4":{"male":38140,"female":36086}},{"role":"Lead Designer","tier1":{"male":31250,"female":25800},"tier2":{"male":36636,"female":31900},"tier3":{"male":40649,"female":43692},"tier4":{"male":50984,"female":40562}},{"role":"Lead Product Manager","tier1":{"male":38364,"female":30857},"tier2":{"male":51494,"female":36923},"tier3":{"male":55664,"female":55400},"tier4":{"male":65629,"female":57611}},{"role":"Legal","tier1":{"male":35471,"female":27400},"tier2":{"male":40889,"female":24500},"tier3":{"male":51000,"female":56000},"tier4":{"male":46455,"female":60714}},{"role":"MLOps","tier1":{"male":28034,"female":28250},"tier2":{"male":52295,"female":31000},"tier3":{"male":54200,"female":31000},"tier4":{"male":80286,"female":null}},{"role":"Machine Learning Engineer","tier1":{"male":29509,"female":27365},"tier2":{"male":41008,"female":34865},"tier3":{"male":52970,"female":46905},"tier4":{"male":59489,"female":50154}},{"role":"Mobile Developer","tier1":{"male":31265,"female":29761},"tier2":{"male":41309,"female":39803},"tier3":{"male":54975,"female":56000},"tier4":{"male":61835,"female":63433}},{"role":"Operations Generalist","tier1":{"male":29188,"female":27000},"tier2":{"male":42000,"female":34786},"tier3":{"male":44686,"female":40333},"tier4":{"male":53036,"female":56217}},{"role":"PR & Communications","tier1":{"male":30929,"female":25438},"tier2":{"male":33688,"female":27324},"tier3":{"male":38208,"female":32793},"tier4":{"male":37926,"female":36781}},{"role":"Performance Marketing","tier1":{"male":26765,"female":27786},"tier2":{"male":33294,"female":28026},"tier3":{"male":41791,"female":34171},"tier4":{"male":47296,"female":46864}},{"role":"Pre-Sales Engineer","tier1":{"male":26857,"female":25500},"tier2":{"male":46364,"female":41000},"tier3":{"male":49300,"female":39500},"tier4":{"male":57109,"female":43714}},{"role":"Product Analyst","tier1":{"male":29933,"female":26455},"tier2":{"male":38341,"female":34886},"tier3":{"male":41753,"female":42107},"tier4":{"male":46164,"female":39240}},{"role":"Product Design (UI/UX)","tier1":{"male":27468,"female":25033},"tier2":{"male":34895,"female":31539},"tier3":{"male":47148,"female":37987},"tier4":{"male":46051,"female":43000}},{"role":"Product Manager","tier1":{"male":29765,"female":32359},"tier2":{"male":41470,"female":36749},"tier3":{"male":49397,"female":44752},"tier4":{"male":56959,"female":50292}},{"role":"Product Marketing","tier1":{"male":34182,"female":26818},"tier2":{"male":34154,"female":32105},"tier3":{"male":55178,"female":40067},"tier4":{"male":54083,"female":49033}},{"role":"Product Owner","tier1":{"male":29000,"female":30971},"tier2":{"male":41345,"female":36625},"tier3":{"male":49532,"female":42934},"tier4":{"male":54726,"female":46911}},{"role":"Project Manager & Delivery Manager","tier1":{"male":35515,"female":31344},"tier2":{"male":43154,"female":39778},"tier3":{"male":53142,"female":52096},"tier4":{"male":58214,"female":53941}},{"role":"QA & Testing","tier1":{"male":30846,"female":34430},"tier2":{"male":38823,"female":36313},"tier3":{"male":50928,"female":47386},"tier4":{"male":55920,"female":49103}},{"role":"Release Engineer","tier1":{"male":28417,"female":20000},"tier2":{"male":43000,"female":null},"tier3":{"male":53941,"female":51000},"tier4":{"male":61216,"female":41000}},{"role":"Research Developer","tier1":{"male":28973,"female":25333},"tier2":{"male":39873,"female":37083},"tier3":{"male":50982,"female":35500},"tier4":{"male":57875,"female":53222}},{"role":"SEO Marketing","tier1":{"male":24333,"female":23667},"tier2":{"male":29902,"female":27452},"tier3":{"male":36788,"female":31514},"tier4":{"male":43776,"female":41567}},{"role":"Sales & Business Development","tier1":{"male":36986,"female":37261},"tier2":{"male":38659,"female":34980},"tier3":{"male":51532,"female":38968},"tier4":{"male":53433,"female":58643}},{"role":"Sales Leadership & Management","tier1":{"male":31889,"female":35143},"tier2":{"male":44520,"female":34273},"tier3":{"male":50938,"female":40917},"tier4":{"male":61565,"female":52357}},{"role":"Scrum Master & Agile Coach","tier1":{"male":29743,"female":27080},"tier2":{"male":38406,"female":32302},"tier3":{"male":44160,"female":40405},"tier4":{"male":50703,"female":46610}},{"role":"Security Engineer","tier1":{"male":31604,"female":33235},"tier2":{"male":49172,"female":45900},"tier3":{"male":60529,"female":51950},"tier4":{"male":61516,"female":61611}},{"role":"Social Media & Community","tier1":{"male":29244,"female":24383},"tier2":{"male":30029,"female":26746},"tier3":{"male":32519,"female":30431},"tier4":{"male":40776,"female":42943}},{"role":"Software Architect","tier1":{"male":35582,"female":55690},"tier2":{"male":48141,"female":47528},"tier3":{"male":64334,"female":69958},"tier4":{"male":70173,"female":62253}},{"role":"Support Engineer","tier1":{"male":28347,"female":23789},"tier2":{"male":33063,"female":45800},"tier3":{"male":39147,"female":36438},"tier4":{"male":43947,"female":36273}},{"role":"SysAdmin","tier1":{"male":25642,"female":23467},"tier2":{"male":31682,"female":30111},"tier3":{"male":38055,"female":45133},"tier4":{"male":44036,"female":38312}},{"role":"Tech Lead","tier1":{"male":35746,"female":60750},"tier2":{"male":44121,"female":43038},"tier3":{"male":54131,"female":51919},"tier4":{"male":59763,"female":53297}},{"role":"Technical Account Management","tier1":{"male":26889,"female":26500},"tier2":{"male":41273,"female":30800},"tier3":{"male":52789,"female":46000},"tier4":{"male":59025,"female":40857}},{"role":"Technical Recruitment","tier1":{"male":22794,"female":23292},"tier2":{"male":40360,"female":25170},"tier3":{"male":35652,"female":32379},"tier4":{"male":53025,"female":32000}},{"role":"Technical Writer","tier1":{"male":28889,"female":22455},"tier2":{"male":37824,"female":29333},"tier3":{"male":41583,"female":31545},"tier4":{"male":44514,"female":40923}},{"role":"Technical artist","tier1":{"male":23714,"female":23333},"tier2":{"male":32800,"female":null},"tier3":{"male":33250,"female":null},"tier4":{"male":56000,"female":null}},{"role":"UX Researcher","tier1":{"male":25152,"female":22631},"tier2":{"male":31289,"female":28683},"tier3":{"male":47846,"female":38182},"tier4":{"male":43818,"female":37824}},{"role":"UX Writer","tier1":{"male":24939,"female":23467},"tier2":{"male":32684,"female":26129},"tier3":{"male":51364,"female":34900},"tier4":{"male":38077,"female":38385}},{"role":"VP of Design","tier1":{"male":20000,"female":25000},"tier2":{"male":42333,"female":41000},"tier3":{"male":55286,"female":44750},"tier4":{"male":63560,"female":44500}},{"role":"VP of Engineering","tier1":{"male":61250,"female":44667},"tier2":{"male":61863,"female":52108},"tier3":{"male":70969,"female":70343},"tier4":{"male":87002,"female":80211}},{"role":"VP of Product","tier1":{"male":31000,"female":41000},"tier2":{"male":55611,"female":46000},"tier3":{"male":65138,"female":76000},"tier4":{"male":79313,"female":73500}}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/gender/GenderCalculator.styled.tsx

function GenderCalculator_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  max-width: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    gap: ",
        ";\n  }\n"
    ]);
    GenderCalculator_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  min-width: 18rem;\n  align-self: center;\n"
    ]);
    GenderCalculator_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: ",
        ";\n  color: ",
        ";\n"
    ]);
    GenderCalculator_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    gap: ",
        ";\n  }\n"
    ]);
    GenderCalculator_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1;\n  font-size: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    GenderCalculator_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  font-family: ",
        ";\n  line-height: 1;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    GenderCalculator_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var GenderCalculator_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f5fd430-0"
})(GenderCalculator_styled_templateObject(), (0,theme/* spacing */.W0)("xl"), (0,theme/* container */.nC)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl3"));
var StyledInputs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f5fd430-1"
})(GenderCalculator_styled_templateObject1(), (0,theme/* spacing */.W0)("lg"));
var StyledOutputs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f5fd430-2"
})(GenderCalculator_styled_templateObject2(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* color */.$_)("set1_04"));
var StyledOutput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f5fd430-3"
})(GenderCalculator_styled_templateObject3(), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("md"));
var StyledLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4f5fd430-4"
})(GenderCalculator_styled_templateObject4(), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("md"));
var GenderCalculator_styled_StyledValue = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4f5fd430-5"
})(GenderCalculator_styled_templateObject5(), (0,theme/* fontWeight */.Ue)("semiBold"), (0,theme/* fontSize */.JB)("xl5"), (0,theme/* fontFamily */.I8)("display"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl7"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl9"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/gender/GenderCalculator.tsx








var GenderCalculator = function() {
    var ref = (0,react.useState)(), currentRole = ref[0], setCurrentRole = ref[1];
    var ref1 = (0,react.useState)(), currentYears = ref1[0], setCurrentYears = ref1[1];
    var ref2 = (0,react.useState)("--"), currentWomenSalary = ref2[0], setCurrentWomenSalary = ref2[1];
    var ref3 = (0,react.useState)("--"), currentMenSalary = ref3[0], setCurrentMenSalary = ref3[1];
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    var ROLES = (0,react.useMemo)(function() {
        return gender_salary_by_role_and_experience_namespaceObject.map(function(param) {
            var role = param.role;
            return {
                label: role,
                value: role
            };
        });
    }, []);
    var YEARS = (0,react.useMemo)(function() {
        return [
            {
                label: "<2",
                value: "tier1"
            },
            {
                label: "2-5",
                value: "tier2"
            },
            {
                label: "5-10",
                value: "tier3"
            },
            {
                label: ">10",
                value: "tier4"
            }
        ];
    }, []);
    var handleRoleChange = function(param) {
        var value = param.value;
        setCurrentRole(value);
    };
    var handleYearsChange = function(param) {
        var value = param.value;
        setCurrentYears(value);
    };
    (0,react.useEffect)(function() {
        if (currentRole !== undefined && currentYears !== undefined) {
            var data = gender_salary_by_role_and_experience_namespaceObject.find(function(data) {
                return data.role === currentRole;
            });
            var _currentYears = data[currentYears], female = _currentYears.female, male = _currentYears.male;
            setCurrentMenSalary(male.toFixed(1));
            setCurrentWomenSalary(female.toFixed(1));
        } else {
            setCurrentMenSalary("--");
            setCurrentWomenSalary("--");
        }
    }, [
        currentRole,
        currentYears
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderCalculator_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInputs, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                        label: t("mantechcar24.gender.calculator-experience.calculator.role"),
                        forId: "genderRole",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelect/* default */.Z, {
                            defaultValue: gender_salary_by_role_namespaceObject[0].role,
                            id: "genderRole",
                            isSmall: true,
                            onChange: handleRoleChange,
                            options: ROLES,
                            matchOrder: false
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                        label: t("mantechcar24.gender.calculator-experience.calculator.years"),
                        forId: "genderRole",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelect/* default */.Z, {
                            defaultValue: YEARS[0].value,
                            id: "genderExperience",
                            isSmall: true,
                            onChange: handleYearsChange,
                            options: YEARS,
                            matchOrder: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOutputs, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOutput, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLabel, {
                                children: t("mantechcar24.gender.calculator-experience.calculator.women")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderCalculator_styled_StyledValue, {
                                children: [
                                    "€",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: currentWomenSalary
                                    }),
                                    "K"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOutput, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLabel, {
                                children: t("mantechcar24.gender.calculator-experience.calculator.men")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderCalculator_styled_StyledValue, {
                                children: [
                                    "€",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: currentMenSalary
                                    }),
                                    "K"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var gender_GenderCalculator = (GenderCalculator);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/gender/Gender.tsx












var Gender = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Gender_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionHero_SectionHero, {
                image: (0,paths/* getPublicPath */.A)("/images/stateSector/2024/gender.png"),
                title: t("mantechcar24.gender.hero.title"),
                desc: t("mantechcar24.gender.hero.desc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar24.gender.females-by-role.title"),
                desc: t("mantechcar24.gender.females-by-role.desc"),
                descExtra: t("mantechcar24.gender.females-by-role.descExtra"),
                shareId: "femalesbyrole",
                emailSubject: t("mantechcar24.share-modal.females-by-role.email-subject"),
                emailMessage: t("mantechcar24.share-modal.females-by-role.email-text"),
                shareMessage: t("mantechcar24.share-modal.females-by-role.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FemaleByRole, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar24.gender.gender-by-role.title"),
                desc: t("mantechcar24.gender.gender-by-role.desc"),
                descExtra: t("mantechcar24.gender.gender-by-role.descExtra"),
                shareId: "genderbyrole",
                emailSubject: t("mantechcar24.share-modal.gender-by-role.email-subject"),
                emailMessage: t("mantechcar24.share-modal.gender-by-role.email-text"),
                shareMessage: t("mantechcar24.share-modal.gender-by-role.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_FemalesVsMalesByRole, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar24.gender.gender-comparison.title"),
                desc: t("mantechcar24.gender.gender-comparison.desc"),
                descExtra: t("mantechcar24.gender.gender-comparison.descExtra"),
                shareId: "gendercomparison",
                emailSubject: t("mantechcar24.share-modal.gender-comparison.email-subject"),
                emailMessage: t("mantechcar24.share-modal.gender-comparison.email-text"),
                shareMessage: t("mantechcar24.share-modal.gender-comparison.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_GenderComparison, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar24.gender.salary-by-gender.title"),
                desc: t("mantechcar24.gender.salary-by-gender.desc"),
                descExtra: t("mantechcar24.gender.salary-by-gender.descExtra"),
                shareId: "salarybygender",
                emailSubject: t("mantechcar24.share-modal.salary-by-gender.email-subject"),
                emailMessage: t("mantechcar24.share-modal.salary-by-gender.email-text"),
                shareMessage: t("mantechcar24.share-modal.salary-by-gender.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_GenderSalaryByRole, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(sectionChart_SectionChart, {
                title: t("mantechcar24.gender.calculator-experience.title"),
                desc: t("mantechcar24.gender.calculator-experience.desc"),
                descExtra: t("mantechcar24.gender.calculator-experience.descExtra"),
                shareId: "gendersalarybyexperience",
                emailSubject: t("mantechcar24.share-modal.calculator-experience.email-subject"),
                emailMessage: t("mantechcar24.share-modal.calculator-experience.email-text"),
                shareMessage: t("mantechcar24.share-modal.calculator-experience.text"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubsectionTitle, {
                        children: t("mantechcar24.gender.calculator-experience.calculator.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gender_GenderCalculator, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubsectionTitle, {
                        children: t("mantechcar24.gender.calculator-experience.salary-gender-experience.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_GenderSalaryByExperience, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var gender_Gender = (Gender);

// EXTERNAL MODULE: ./components/shared/ButtonLink.js
var ButtonLink = __webpack_require__(68692);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/insights/Insights.constants.tsx

var INSIGHTSDATA = function(t, locale) {
    return [
        {
            image: (0,paths/* getPublicPath */.A)("/images/stateSector/2024/insights-summary.png"),
            title: t("mantechcar24.insights.summary-title"),
            text: t("mantechcar24.insights.summary-desc"),
            url_es: "https://www.getmanfred.com/blog/tech-career-report-resumen-2024",
            url_en: "https://www.getmanfred.com/en/blog/tech-career-report-resumen-2024"
        },
        {
            image: (0,paths/* getPublicPath */.A)("/images/stateSector/2024/insights-hybrid.png"),
            title: t("mantechcar24.insights.hybrid-title"),
            text: t("mantechcar24.insights.hybrid-desc"),
            url_es: "https://www.getmanfred.com/blog/la-vuelta-al-hibrido",
            url_en: "https://www.getmanfred.com/en/blog/la-vuelta-al-hibrido"
        },
        {
            image: (0,paths/* getPublicPath */.A)("/images/stateSector/2024/insights-salaries.png"),
            title: t("mantechcar24.insights.salaries-title"),
            text: t("mantechcar24.insights.salaries-desc"),
            url_es: "https://www.getmanfred.com/blog/tech-career-report-alarios",
            url_en: "https://www.getmanfred.com/en/blog/tech-career-report-alarios"
        },
        {
            image: (0,paths/* getPublicPath */.A)("/images/stateSector/2024/insights-soft-skills.png"),
            title: t("mantechcar24.insights.soft-skills-title"),
            text: t("mantechcar24.insights.soft-skills-desc"),
            url_es: "https://www.getmanfred.com/blog/las-soft-skills-olvidadas",
            url_en: "https://www.getmanfred.com/en/blog/las-soft-skills-olvidadas"
        },
        {
            image: (0,paths/* getPublicPath */.A)("/images/stateSector/2024/insights-ia.png"),
            title: t("mantechcar24.insights.ia-title"),
            text: t("mantechcar24.insights.ia-desc"),
            url_es: "https://www.getmanfred.com/blog/el-auge-de-la-ia",
            url_en: "https://www.getmanfred.com/en/blog/el-auge-de-la-ia"
        }
    ];
};

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/insights/Insights.styled.tsx

function Insights_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    Insights_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Insights_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  padding: ",
        " ",
        ";\n  margin: auto;\n"
    ]);
    Insights_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Insights_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: ",
        ";\n  margin: ",
        " 0;\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n"
    ]);
    Insights_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Insights_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: center;\n    gap: ",
        ";\n  }\n"
    ]);
    Insights_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Insights_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  width: 12.5rem;\n  height: 12.5rem;\n"
    ]);
    Insights_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Insights_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  flex-direction: column;\n  align-items: flex-start;\n  font-size: ",
        ";\n  line-height: 1.5;\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    Insights_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Insights_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    Insights_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e157f30-0"
})(Insights_styled_templateObject(), (0,theme/* color */.$_)("midnight_100"));
var Insights_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e157f30-1"
})(Insights_styled_templateObject1(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("md"));
var StyledList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e157f30-2"
})(Insights_styled_templateObject2(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"));
var Insights_styled_StyledItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e157f30-3"
})(Insights_styled_templateObject3(), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("lg"));
var StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-2e157f30-4"
})(Insights_styled_templateObject4());
var Insights_styled_StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2e157f30-5"
})(Insights_styled_templateObject5(), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("md"));
var StyledTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-2e157f30-6"
})(Insights_styled_templateObject6(), (0,theme/* fontSize */.JB)("xl"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl2"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/insights/Insights.tsx









var Insights = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    var locale = (0,router.useRouter)().locale;
    var insightsData = INSIGHTSDATA(t, locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Insights_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                    as: "h4",
                    editorial: true,
                    alignLeft: true,
                    children: t("mantechcar24.insights.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledList, {
                    children: insightsData.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Insights_styled_StyledItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                                    src: item.image,
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Insights_styled_StyledContent, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: item.text
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                                            href: locale === "es" ? item.url_es : item.url_en,
                                            variant: "secondary",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("mantechcar24.insights.keep-reading")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: pro_light_svg_icons/* faArrowRight */.eFW
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var insights_Insights = (Insights);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/intro/Intro.constants.tsx
var INTRODATA = function(t, locale, manfreditesCount) {
    return [
        {
            value: manfreditesCount.toLocaleString(locale),
            text: t("mantechcar24.data.people")
        },
        {
            value: "+55.000",
            text: t("mantechcar24.data.current")
        },
        {
            value: "50%",
            text: t("mantechcar24.data.companies")
        },
        {
            value: "+650",
            text: t("mantechcar24.data.time-to-hire")
        }
    ];
};

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/intro/Intro.styled.tsx

function Intro_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  padding: ",
        " ",
        " ",
        ";\n  margin: auto;\n"
    ]);
    Intro_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.5;\n  color: var(--headingColor);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    font-size: ",
        ";\n    line-height: 1.4;\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n  }\n"
    ]);
    Intro_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    max-width: 25rem;\n  }\n  @media (min-width: ",
        ") {\n    max-width: 33rem;\n  }\n"
    ]);
    Intro_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 47rem;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  font-size: ",
        ";\n  font-family: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  .pretitle {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: 1;\n    text-transform: uppercase;\n    font-weight: ",
        ";\n    letter-spacing: 0.35em;\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n\n  .year {\n    font-family: inherit;\n    font-size: inherit;\n    letter-spacing: 0;\n    display: inline-flex;\n    flex-direction: column;\n\n    &::after {\n      content: '';\n      background-image: ",
        ";\n      background-repeat: no-repeat;\n      background-size: contain;\n      height: ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      display: flex;\n      font-size: ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: 10rem;\n      &::after {\n        height: ",
        ";\n      }\n    }\n  }\n"
    ]);
    Intro_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n\n  @media (min-width: ",
        ") {\n    margin-top: ",
        ";\n  }\n"
    ]);
    Intro_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n  line-height: 1.5;\n\n  &:not(.display-full-text) {\n    display: -webkit-box;\n    -webkit-line-clamp: 6;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    word-break: break-word;\n\n    @media (min-width: ",
        ") {\n      -webkit-line-clamp: 10;\n    }\n  }\n\n  > :first-child {\n    margin-top: 0;\n  }\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    Intro_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n\n  &::before {\n    content: '\uD83C\uDFC3‍♂️\uD83D\uDCA8';\n    display: block;\n  }\n"
    ]);
    Intro_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    Intro_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  line-height: 1.2;\n  text-transform: uppercase;\n  letter-spacing: 0.35em;\n  margin-top: 0;\n  font-weight: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n  text-align: center;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  &::before,\n  &::after {\n    content: '';\n    height: 1px;\n    background-color: ",
        ";\n    flex-grow: 1;\n  }\n"
    ]);
    Intro_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: ",
        ";\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n"
    ]);
    Intro_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.25;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  flex-shrink: 0;\n  width: auto;\n  text-align: center;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  flex-direction: column;\n  text-align: center;\n\n  &::before {\n    content: '';\n    display: block;\n    width: ",
        ";\n    height: ",
        ";\n    background-color: ",
        ";\n    margin-left: auto;\n    margin-right: auto;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}




var Intro_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-342ffcd6-0"
})(Intro_styled_templateObject(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var Intro_styled_StyledHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-342ffcd6-1"
})(Intro_styled_templateObject1(), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("xl"), (0,theme/* spacing */.W0)("xl5"));
var Intro_styled_StyledHeroImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-342ffcd6-2"
})(Intro_styled_templateObject2(), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("xl"));
var Intro_styled_StyledHeroTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography_styled/* Heading1 */.nL).withConfig({
    componentId: "sc-342ffcd6-3"
})(Intro_styled_templateObject3(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("xl4"), (0,theme/* fontFamily */.I8)("sans"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl6"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl9"), (0,theme/* fontFamily */.I8)("sans"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* screen */.sp)("xl"), (0,theme/* fontSize */.JB)("xl3"), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/stateSector/2024/hero-highlight.svg"), "')");
}, (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl10"), (0,theme/* screen */.sp)("xl"), (0,theme/* spacing */.W0)("xl4"));
var StyledIntro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-342ffcd6-4"
})(Intro_styled_templateObject4(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl4"));
var StyledIntroText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-342ffcd6-5"
})(Intro_styled_templateObject5(), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"));
var StyledIntroTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography_styled/* Heading2 */.XJ).withConfig({
    componentId: "sc-342ffcd6-6"
})(Intro_styled_templateObject6(), (0,theme/* spacing */.W0)("md"));
var Intro_styled_StyledData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-342ffcd6-7"
})(Intro_styled_templateObject7(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var Intro_styled_StyledDataTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-342ffcd6-8"
})(Intro_styled_templateObject8(), (0,theme/* fontFamily */.I8)("sans"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* color */.$_)("midnight_900"));
var StyledDataList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-342ffcd6-9"
})(Intro_styled_templateObject9(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"));
var StyledDataItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-342ffcd6-10"
})(_templateObject10(), (0,theme/* spacing */.W0)("md"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("xs"));
var StyledDataValue = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-342ffcd6-11"
})(_templateObject11(), (0,theme/* color */.$_)("navy_500"), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontWeight */.Ue)("semiBold"), (0,theme/* fontSize */.JB)("xl6"));
var StyledDataContent = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-342ffcd6-12"
})(_templateObject12(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("navy_200"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/intro/Intro.tsx











var Intro = function(param) {
    var manfreditesCount = param.manfreditesCount;
    var checkLineClamp = function checkLineClamp() {
        if (clampableText.current && clampableText.current.clientHeight < clampableText.current.scrollHeight) {
            setdisplayReadMore(true);
        } else {
            setdisplayReadMore(false);
        }
    };
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    var locale = (0,router.useRouter)().locale;
    var introData = INTRODATA(t, locale, manfreditesCount);
    var ref = (0,react.useState)(false), displayReadMore = ref[0], setdisplayReadMore = ref[1];
    var clampableText = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        checkLineClamp();
    }, []);
    var ref1 = (0,react.useState)(false), showAllText = ref1[0], setShowAllText = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intro_styled_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intro_styled_StyledHero, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro_styled_StyledHeroImage, {
                        src: (0,paths/* getPublicPath */.A)("/images/stateSector/2024/hero.jpg"),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intro_styled_StyledHeroTitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "pretitle",
                                children: t("mantechcar24.hero.pre-title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    t("mantechcar24.hero.title"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "year",
                                        children: "2024"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledIntro, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIntroTitle, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "developer-career-report-2024",
                            i18nKey: "mantechcar24.hero.intro-title"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIntroText, {
                        ref: clampableText,
                        className: "".concat(showAllText ? "display-full-text" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "developer-career-report-2024",
                            i18nKey: "mantechcar24.hero.intro"
                        })
                    }),
                    displayReadMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                        type: "button",
                        onClick: function() {
                            return setShowAllText(!showAllText);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: !showAllText ? pro_solid_svg_icons/* faPlusCircle */.KtF : pro_solid_svg_icons/* faMinusCircle */.uMC
                            }),
                            !showAllText && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("mantechcar24.hero.read-more")
                            }),
                            showAllText && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("mantechcar24.hero.read-less")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intro_styled_StyledData, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro_styled_StyledDataTitle, {
                        children: t("mantechcar24.data.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDataList, {
                        children: introData.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDataValue, {
                                        children: item.value
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDataContent, {
                                        children: item.text
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var intro_Intro = (Intro);

// EXTERNAL MODULE: ./components/shared/accordion/Accordion.tsx + 1 modules
var Accordion = __webpack_require__(71065);
;// CONCATENATED MODULE: ./data/mantechcar24/methodology-experience.json
var methodology_experience_namespaceObject = JSON.parse('[{"exp":"<2","share":27.94,"fill":"#08306B"},{"exp":"2-5","share":20.41,"fill":"#08519C"},{"exp":"5-10","share":17.85,"fill":"#2171B5"},{"exp":"10+","share":14.05,"fill":"#4292C6"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/methodology/charts/MethodologyExperience.tsx




var MethodologyExperience = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "methodology",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 180,
                width: "99%",
                minWidth: 400,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: methodology_experience_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 10
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "exp",
                            tickLine: false,
                            width: 120
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "transparent"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-x"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "share",
                            barSize: 8,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MethodologyExperience = (MethodologyExperience);

;// CONCATENATED MODULE: ./data/mantechcar24/methodology-gender.json
var methodology_gender_namespaceObject = JSON.parse('[{"name":"f","value":16611,"fill":"#6A3D99"},{"name":"m","value":77535,"fill":"#1E77B3"},{"name":"u","value":1875,"fill":"#F2F2F2"}]');
// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/PieChart.js
var PieChart = __webpack_require__(43454);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/polar/Pie.js
var Pie = __webpack_require__(79941);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/Cell.js
var Cell = __webpack_require__(11011);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/methodology/charts/MethodologyGender.tsx






var MethodologyGender = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "methodology gender",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PieChart/* PieChart */.u, {
                width: 400,
                height: 400,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                        layout: "vertical",
                        align: "right",
                        verticalAlign: "top",
                        iconType: "square",
                        width: 120
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        cursor: {
                            fill: "transparent"
                        },
                        labelStyle: {
                            display: "none"
                        },
                        separator: ": ",
                        formatter: function(value) {
                            return value.toLocaleString(locale);
                        },
                        wrapperClassName: "tooltip-y"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Pie/* Pie */.b, {
                        data: methodology_gender_namespaceObject,
                        dataKey: "value",
                        cx: "50%",
                        cy: "28%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                name: t("mantechcar24.methodology.gender.females")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                name: t("mantechcar24.methodology.gender.males")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                name: t("mantechcar24.methodology.gender.undefined")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var charts_MethodologyGender = (MethodologyGender);

;// CONCATENATED MODULE: ./data/mantechcar24/methodology-roles.json
var methodology_roles_namespaceObject = JSON.parse('[{"role":"Backend Developer","share":29.2,"fill":"#08306B"},{"role":"Frontend Developer","share":22.84,"fill":"#08306B"},{"role":"Full-Stack Developer","share":22.24,"fill":"#08519C"},{"role":"Software Architect","share":5.82,"fill":"#08519C"},{"role":"Project Manager & Delivery Manager","share":5.65,"fill":"#2171B5"},{"role":"Mobile Developer","share":5.38,"fill":"#2171B5"},{"role":"Data Scientist","share":5.1,"fill":"#4292C6"},{"role":"DevOps & Infrastructure & SRE","share":5.06,"fill":"#4292C6"},{"role":"Engineering Management","share":4.71,"fill":"#6BAED6"},{"role":"Data Engineer","share":4.27,"fill":"#6BAED6"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/methodology/charts/MethodologyRoles.tsx




var MethodologyRoles = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "methodology",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 330,
                width: "99%",
                minWidth: 400,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: methodology_roles_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 10
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "role",
                            tickLine: false,
                            width: 160
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "transparent"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-x"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "share",
                            barSize: 8,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MethodologyRoles = (MethodologyRoles);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/methodology/Methodology.constants.tsx






var genderAccordion = function(t) {
    return [
        {
            summary: t("mantechcar24.methodology.gender.api-title"),
            details: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "developer-career-report-2024",
                i18nKey: "mantechcar24.methodology.gender.api-content"
            })
        },
        {
            summary: t("mantechcar24.methodology.gender.question-title"),
            details: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "developer-career-report-2024",
                i18nKey: "mantechcar24.methodology.gender.question-content"
            })
        }
    ];
};
var METHODOLOGYSECTIONS = function(t) {
    return [
        {
            title: t("mantechcar24.methodology.experience.title"),
            desc: "mantechcar24.methodology.experience.desc",
            chart: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MethodologyExperience, {})
        },
        {
            title: t("mantechcar24.methodology.roles.title"),
            desc: "mantechcar24.methodology.roles.desc",
            chart: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MethodologyRoles, {})
        },
        {
            title: t("mantechcar24.methodology.gender.title"),
            desc: "mantechcar24.methodology.gender.desc",
            chart: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MethodologyGender, {}),
            accordion: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                items: genderAccordion(t)
            })
        }
    ];
};

// EXTERNAL MODULE: ./components/shared/accordion/Accordion.styled.tsx
var Accordion_styled = __webpack_require__(28619);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/methodology/Methodology.styled.tsx

function Methodology_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    Methodology_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  text-align: left;\n  padding: ",
        " ",
        ";\n"
    ]);
    Methodology_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.6;\n"
    ]);
    Methodology_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  border-bottom: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n"
    ]);
    Methodology_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 22rem;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  flex-grow: 1;\n\n  p {\n    margin-top: 0;\n    line-height: 1.5;\n  }\n\n  ",
        " {\n    border: 1px solid ",
        ";\n    border-radius: ",
        ";\n  }\n\n  ",
        ":first-child {\n    ",
        " {\n      border-top: 0;\n    }\n  }\n\n  ",
        " {\n    padding: ",
        ";\n  }\n\n  ",
        " {\n    font-size: ",
        ";\n  }\n\n  ",
        " {\n    font-size: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n  }\n"
    ]);
    Methodology_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  text-transform: uppercase;\n  letter-spacing: 0.35em;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    Methodology_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n"
    ]);
    Methodology_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1.5;\n  padding-top: ",
        ";\n\n  a {\n    font-weight: ",
        ";\n  }\n"
    ]);
    Methodology_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var Methodology_styled_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef50c3ca-0"
})(Methodology_styled_templateObject(), (0,theme/* color */.$_)("white"));
var Methodology_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef50c3ca-1"
})(Methodology_styled_templateObject1(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"));
var Methodology_styled_StyledDesc = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-ef50c3ca-2"
})(Methodology_styled_templateObject2(), (0,theme/* fontSize */.JB)("lg"));
var Methodology_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef50c3ca-3"
})(Methodology_styled_templateObject3(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* screen */.sp)("md"));
var StyledSectionContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef50c3ca-4"
})(Methodology_styled_templateObject4(), (0,theme/* spacing */.W0)("lg"), Accordion_styled/* StyledAccordion */.sB, (0,theme/* color */.$_)("midnight_200"), (0,theme/* radius */.q0)("md"), Accordion_styled/* StyledAccordionItem */.wW, Accordion_styled/* StyledSummary */.WQ, Accordion_styled/* StyledTrigger */.tr, (0,theme/* spacing */.W0)("md"), Accordion_styled/* StyledTitle */.X0, (0,theme/* fontSize */.JB)("md"), Accordion_styled/* StyledContent */.Hz, (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledSectionTitle = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
    componentId: "sc-ef50c3ca-5"
})(Methodology_styled_templateObject5(), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledSectionChart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef50c3ca-6"
})(Methodology_styled_templateObject6());
var StyledThanks = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-ef50c3ca-7"
})(Methodology_styled_templateObject7(), (0,theme/* spacing */.W0)("md"), (0,theme/* fontWeight */.Ue)("extraBold"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/methodology/MethodologySection.tsx



var MethodologySection = function(param) {
    var title = param.title, desc = param.desc, chart = param.chart, accordion = param.accordion;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Methodology_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSectionContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSectionTitle, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "developer-career-report-2024",
                            i18nKey: desc
                        })
                    }),
                    accordion && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: accordion
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSectionChart, {
                children: chart
            })
        ]
    });
};
/* harmony default export */ var methodology_MethodologySection = (MethodologySection);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/methodology/Methodology.tsx







var Methodology = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    var sections = METHODOLOGYSECTIONS(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Methodology_styled_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Methodology_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                    editorial: true,
                    alignLeft: true,
                    as: "h5",
                    children: t("mantechcar24.methodology.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Methodology_styled_StyledDesc, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                        ns: "developer-career-report-2024",
                        i18nKey: "mantechcar24.methodology.desc"
                    })
                }),
                sections.map(function(section, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(methodology_MethodologySection, {
                        title: section.title,
                        desc: section.desc,
                        chart: section.chart,
                        accordion: section.accordion
                    }, index);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledThanks, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                        ns: "developer-career-report-2024",
                        i18nKey: "mantechcar24.methodology.thanks"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var methodology_Methodology = (Methodology);

;// CONCATENATED MODULE: ./data/mantechcar24/roles-distribution.json
var roles_distribution_namespaceObject = JSON.parse('[{"name":"Backend Developer","value":29.2037230581,"fill":"#084081"},{"name":"Frontend Developer","value":22.8372542446,"fill":"#0868AC"},{"name":"Full-Stack Developer","value":22.2367928063,"fill":"#2B8CBE"},{"name":"Software Architect","value":5.8231941788,"fill":"#50B4D3"},{"name":"Project Manager & Delivery Manager","value":5.6496618091,"fill":"#7BCCC4"},{"name":"Mobile Developer","value":5.3824613989,"fill":"#A8DDB5"},{"name":"Data Scientist","value":5.09751336,"fill":"#CDEBC6"},{"name":"DevOps & Infrastructure & SRE","value":5.055116247,"fill":"#E0F3DB"},{"name":"Marketing","value":4.9703220209,"fill":"#F7FCF0"},{"name":"Engineering Management","value":4.7090374869,"fill":"green"},{"name":"Operaciones y Estrategia","value":4.645934807,"fill":"#084081"},{"name":"Software Engineering","value":4.4329632624,"fill":"#0868AC"},{"name":"Data Engineer","value":4.2742205833,"fill":"#2B8CBE"},{"name":"Data Analyst & BI","value":4.0237818225,"fill":"#50B4D3"},{"name":"Tech Lead","value":3.7339038867,"fill":"#7BCCC4"},{"name":"Ventas y Gestión de Cuentas","value":3.5169884246,"fill":"#A8DDB5"},{"name":"Product Design (UI/UX)","value":3.2083768808,"fill":"#CDEBC6"},{"name":"QA & Testing","value":3.0762556447,"fill":"#E0F3DB"},{"name":"VP of Engineering","value":2.6641162667,"fill":"#F7FCF0"},{"name":"Diseño","value":2.5053735876,"fill":"green"},{"name":"Otros (Ingeniería)","value":2.4925558557,"fill":"#084081"},{"name":"Producto","value":2.3988878153,"fill":"#0868AC"},{"name":"Product Manager","value":1.9246317367,"fill":"#2B8CBE"},{"name":"Finanzas, Legal y Compliance","value":1.8161740056,"fill":"#50B4D3"},{"name":"Machine Learning Engineer","value":1.3014927728,"fill":"#7BCCC4"},{"name":"SysAdmin","value":1.2955768965,"fill":"#A8DDB5"},{"name":"People, RR.HH, Recruitment","value":1.2837451441,"fill":"#CDEBC6"}]');
// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/Treemap.js + 1 modules
var Treemap = __webpack_require__(65701);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/charts/RolesDistribution.tsx




var RolesDistribution = function() {
    var COLORS = [
        "#08306B",
        "#081D58",
        "#0868AC",
        "#08519C",
        "#253494",
        "#2B8CBE",
        "#2171B5",
        "#50B4D3",
        "#4292C6",
        "#1D91C0",
        "#7BCCC4",
        "#41B6C4",
        "#6BAED6",
        "#A8DDB5"
    ];
    var CustomContent = function(param) {
        var root = param.root, x = param.x, y = param.y, width = param.width, height = param.height, index = param.index, colors = param.colors, name = param.name;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    style: {
                        fill: colors[Math.floor(index / root.children.length * 14)],
                        stroke: "#fff",
                        strokeWidth: 1
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("foreignObject", {
                    x: x + 5,
                    y: y,
                    width: width,
                    height: height,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            color: "#fff",
                            fontSize: "12px",
                            fontWeight: 500,
                            marginRight: "5px",
                            marginTop: "10px",
                            lineHeight: 1.2,
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        },
                        children: name
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "treemap",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: "99%",
                height: 450,
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Treemap/* Treemap */.W, {
                    data: roles_distribution_namespaceObject,
                    aspectRatio: 16 / 9,
                    nameKey: "name",
                    stroke: "#fff",
                    fill: "#FFF8DF",
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomContent, {
                        colors: COLORS
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        cursor: {
                            fill: "#ebe8df"
                        },
                        formatter: function(value, name) {
                            return [
                                value.toFixed(1) + "%",
                                name
                            ];
                        }
                    })
                })
            })
        })
    });
};
/* harmony default export */ var charts_RolesDistribution = (RolesDistribution);

;// CONCATENATED MODULE: ./data/mantechcar24/soft-skills.json
var soft_skills_namespaceObject = JSON.parse('[{"skill":{"en":"Teamwork","es":"Trabajo en equipo"},"offers":58.95117540687161,"users":32.17125382262997},{"skill":{"en":"Proactivity","es":"Proactividad"},"offers":41.77215189873418,"users":18.893522379760913},{"skill":{"en":"Continuous Learning","es":"Aprendizaje Continuo"},"offers":37.522603978300175,"users":43.89213233249931},{"skill":{"en":"Self-management","es":"Capacidad de autogestión"},"offers":34.35804701627486,"users":11.820961912705032},{"skill":{"en":"Attention to detail","es":"Atención al detalle"},"offers":30.65099457504521,"users":16.46371976647206},{"skill":{"en":"Adaptability to change","es":"Adaptabilidad al cambio"},"offers":28.75226039783002,"users":32.34361968306922},{"skill":{"en":"Verbal communication","es":"Comunicación verbal"},"offers":22.24231464737794,"users":4.209063108145677},{"skill":{"en":"Analytical thinking","es":"Pensamiento analítico"},"offers":19.349005424954793,"users":20.656102307478456},{"skill":{"en":"Autonomy in learning","es":"Autonomía en el aprendizaje"},"offers":15.641952983725135,"users":19.621907144842922},{"skill":{"en":"Written communication","es":"Comunicación escrita"},"offers":12.296564195298371,"users":2.096191270503197},{"skill":{"en":"Leadership","es":"Liderazgo"},"offers":12.115732368896925,"users":11.387267167083682},{"skill":{"en":"Ability to give feedback","es":"Capacidad de dar feedback"},"offers":9.945750452079565,"users":3.797609118710036},{"skill":{"en":"Team management","es":"Gestión de equipo"},"offers":6.871609403254973,"users":7.406171809841535},{"skill":{"en":"Ability to receive feedback","es":"Capacidad de recibir feedback"},"offers":6.871609403254973,"users":6.182930219627467},{"skill":{"en":"Strategic vision","es":"Visión estratégica"},"offers":5.605786618444846,"users":6.466499860995274},{"skill":{"en":"Listening skills","es":"Capacidad de escucha"},"offers":5.334538878842676,"users":7.4395329441201},{"skill":{"en":"Creative thinking","es":"Pensamiento creativo"},"offers":4.3399638336347195,"users":9.852654990269668},{"skill":{"en":"Critical thinking","es":"Visión crítica"},"offers":3.1645569620253164,"users":4.798443147067},{"skill":{"en":"Emotional intelligence","es":"Inteligencia emocional"},"offers":3.1645569620253164,"users":6.927995551848763},{"skill":{"en":"Negotiation skills","es":"Habilidades de negociación"},"offers":3.074141048824593,"users":1.2121212121212122},{"skill":{"en":"Mentorship ability","es":"Capacidad de mentorización"},"offers":2.802893309222423,"users":5.743675284959688},{"skill":{"en":"Tolerance to uncertainty","es":"Tolerancia a la incertidumbre"},"offers":1.89873417721519,"users":1.595774256324715},{"skill":{"en":"Abstract thinking","es":"Capacidad de abstracción"},"offers":1.62748643761302,"users":5.99388379204893},{"skill":{"en":"Intercultural communication","es":"Comunicación intercultural"},"offers":1.62748643761302,"users":1.6624965248818462},{"skill":{"en":"Presentation skills","es":"Capacidad de presentación"},"offers":1.5370705244122964,"users":1.7625799277175422},{"skill":{"en":"Resilience to frustration","es":"Resistencia a la frustración"},"offers":0.3616636528028933,"users":3.736447039199333}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/charts/SoftSkillsCommunityVsOffered.tsx






var SoftSkillsCommunityVsOffered = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "skills",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: "99%",
                height: 950,
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: soft_skills_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: function(data) {
                                return data.skill[locale || "en"];
                            },
                            tickLine: false,
                            width: 200
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#ebe8df"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: ": ",
                            formatter: function(value, name) {
                                return [
                                    value.toFixed(1) + "%",
                                    name
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                            layout: "horizontal",
                            iconType: "square",
                            wrapperStyle: {
                                bottom: 0
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "offers",
                            name: t("mantechcar24.talent.competences.companies"),
                            fill: "#7EAFD3",
                            barSize: 8,
                            radius: 5
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "users",
                            name: t("mantechcar24.talent.competences.community"),
                            fill: "#8DD3C7",
                            barSize: 8,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_SoftSkillsCommunityVsOffered = (SoftSkillsCommunityVsOffered);

;// CONCATENATED MODULE: ./data/mantechcar24/talent-by-technology-backend.json
var talent_by_technology_backend_namespaceObject = JSON.parse('[{"tech":"Python","position":1,"shareValue":22.29,"experienceTier1":32.81,"experienceTier2":29.67,"experienceTier3":21.35,"experienceTier4":16.18},{"tech":"Java","position":2,"shareValue":21.39,"experienceTier1":30.18,"experienceTier2":25.84,"experienceTier3":23.24,"experienceTier4":20.74},{"tech":"NodeJS","position":3,"shareValue":17.84,"experienceTier1":32.35,"experienceTier2":29.79,"experienceTier3":23.76,"experienceTier4":14.1},{"tech":"PHP","position":4,"shareValue":12.38,"experienceTier1":25.92,"experienceTier2":23.24,"experienceTier3":26.21,"experienceTier4":24.63},{"tech":"C#","position":5,"shareValue":8.4,"experienceTier1":24.61,"experienceTier2":25.9,"experienceTier3":25.24,"experienceTier4":24.24},{"tech":"C++","position":6,"shareValue":4.82,"experienceTier1":29.82,"experienceTier2":26.64,"experienceTier3":22.25,"experienceTier4":21.29},{"tech":"Go","position":7,"shareValue":2.33,"experienceTier1":11.54,"experienceTier2":27.03,"experienceTier3":33.03,"experienceTier4":28.4},{"tech":"Ruby","position":8,"shareValue":1.52,"experienceTier1":22.13,"experienceTier2":23.74,"experienceTier3":30.05,"experienceTier4":24.08},{"tech":"Rust","position":9,"shareValue":0.54,"experienceTier1":15.53,"experienceTier2":27.08,"experienceTier3":29.17,"experienceTier4":28.22}]');
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/LabelList.js
var LabelList = __webpack_require__(96621);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/charts/TalentByTech.styled.tsx

function TalentByTech_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: auto auto repeat(2, minmax(0, 1fr));\n  margin-bottom: ",
        ";\n"
    ]);
    TalentByTech_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TalentByTech_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  border-bottom: 1px solid ",
        ";\n  font-size: ",
        ";\n\n  &.hasChart {\n    padding: ",
        " ",
        ";\n  }\n\n  .recharts-label {\n    font-size: ",
        ";\n  }\n"
    ]);
    TalentByTech_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TalentByTech_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  border-bottom: 1px solid ",
        ";\n  border-top: 1px solid ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n"
    ]);
    TalentByTech_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var TalentByTech_styled_StyledTable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4918cd5a-0"
})(TalentByTech_styled_templateObject(), (0,theme/* spacing */.W0)("md"));
var StyledCell = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4918cd5a-1"
})(TalentByTech_styled_templateObject1(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("xs"));
var StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4918cd5a-2"
})(TalentByTech_styled_templateObject2(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("black"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/charts/TalentByTechBackend.tsx







var TalentByTechBackend = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentByTech_styled_StyledTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.order")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.technology")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.talent-share")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.years-experience")
                }),
                talent_by_technology_backend_namespaceObject.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.position
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.tech
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "99%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            margin: {
                                                left: 18
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        25
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "shareValue",
                                                    fill: "#9dcac2",
                                                    barSize: 8,
                                                    radius: 12,
                                                    isAnimationActive: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function(shareValue) {
                                                            return "".concat(shareValue, "%");
                                                        },
                                                        position: "right"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "100%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        100
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier1",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#DEEBF7",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "0-2";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier2",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#6BAED6",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "2-5";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier3",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#2171B5",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "5-10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier4",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#08306B",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "+10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var charts_TalentByTechBackend = (TalentByTechBackend);

;// CONCATENATED MODULE: ./data/mantechcar24/talent-by-technology-data.json
var talent_by_technology_data_namespaceObject = JSON.parse('[{"tech":"Pandas","position":1,"shareValue":3.08,"experienceTier1":42.01,"experienceTier2":33.1,"experienceTier3":16.75,"experienceTier4":8.14},{"tech":"R","position":2,"shareValue":2.14,"experienceTier1":38.66,"experienceTier2":31.94,"experienceTier3":18.11,"experienceTier4":11.29},{"tech":"Spark","position":3,"shareValue":1.57,"experienceTier1":20.37,"experienceTier2":33.74,"experienceTier3":28.28,"experienceTier4":17.61},{"tech":"Scala","position":4,"shareValue":0.97,"experienceTier1":15.42,"experienceTier2":27.03,"experienceTier3":32.63,"experienceTier4":24.92},{"tech":"Hadoop","position":5,"shareValue":0.64,"experienceTier1":23.61,"experienceTier2":28.37,"experienceTier3":25.52,"experienceTier4":22.5}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/charts/TalentByTechData.tsx







var TalentByTechData = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentByTech_styled_StyledTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.order")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.technology")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.talent-share")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.years-experience")
                }),
                talent_by_technology_data_namespaceObject.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.position
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.tech
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "99%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            margin: {
                                                left: 18
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        25
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "shareValue",
                                                    fill: "#9dcac2",
                                                    barSize: 8,
                                                    radius: 12,
                                                    isAnimationActive: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function(shareValue) {
                                                            return "".concat(shareValue, "%");
                                                        },
                                                        position: "right"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "100%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        100
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier1",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#DEEBF7",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "0-2";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier2",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#6BAED6",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "2-5";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier3",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#2171B5",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "5-10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier4",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#08306B",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "+10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var charts_TalentByTechData = (TalentByTechData);

;// CONCATENATED MODULE: ./data/mantechcar24/talent-by-technology-frontend.json
var talent_by_technology_frontend_namespaceObject = JSON.parse('[{"tech":"React","position":1,"shareValue":21.48,"experienceTier1":36.96,"experienceTier2":30.02,"experienceTier3":21.81,"experienceTier4":11.2},{"tech":"Angular2+","position":2,"shareValue":9.36,"experienceTier1":24.03,"experienceTier2":30.16,"experienceTier3":28.9,"experienceTier4":16.91},{"tech":"Vue","position":3,"shareValue":7,"experienceTier1":21.19,"experienceTier2":33.07,"experienceTier3":30.07,"experienceTier4":15.67}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/charts/TalentByTechFrontend.tsx







var TalentByTechFrontend = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentByTech_styled_StyledTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.order")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.technology")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.talent-share")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.years-experience")
                }),
                talent_by_technology_frontend_namespaceObject.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.position
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.tech
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "99%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            margin: {
                                                left: 18
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        25
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "shareValue",
                                                    fill: "#9dcac2",
                                                    barSize: 8,
                                                    radius: 12,
                                                    isAnimationActive: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function(shareValue) {
                                                            return "".concat(shareValue, "%");
                                                        },
                                                        position: "right"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "100%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        100
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier1",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#DEEBF7",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "0-2";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier2",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#6BAED6",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "2-5";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier3",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#2171B5",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "5-10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier4",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#08306B",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "+10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var charts_TalentByTechFrontend = (TalentByTechFrontend);

;// CONCATENATED MODULE: ./data/mantechcar24/talent-by-technology-infra_sistemas.json
var talent_by_technology_infra_sistemas_namespaceObject = JSON.parse('[{"tech":"AWS","position":1,"shareValue":10.8,"experienceTier1":13.49,"experienceTier2":27.89,"experienceTier3":31.71,"experienceTier4":26.9},{"tech":"Azure","position":2,"shareValue":5.33,"experienceTier1":13.54,"experienceTier2":29.13,"experienceTier3":28.72,"experienceTier4":28.61},{"tech":"Kubernetes","position":3,"shareValue":5.05,"experienceTier1":10.07,"experienceTier2":26.12,"experienceTier3":32.06,"experienceTier4":31.74},{"tech":"Google Cloud","position":4,"shareValue":3.56,"experienceTier1":15.3,"experienceTier2":27.28,"experienceTier3":30.28,"experienceTier4":27.14},{"tech":"Bash","position":5,"shareValue":3.03,"experienceTier1":20.56,"experienceTier2":27.76,"experienceTier3":26.23,"experienceTier4":25.45},{"tech":"Terraform","position":6,"shareValue":2.27,"experienceTier1":9.6,"experienceTier2":27.52,"experienceTier3":31.33,"experienceTier4":31.55},{"tech":"Ansible","position":7,"shareValue":0.97,"experienceTier1":7.74,"experienceTier2":22.48,"experienceTier3":27.15,"experienceTier4":42.63},{"tech":"PowerShell","position":8,"shareValue":0.41,"experienceTier1":15.79,"experienceTier2":23.42,"experienceTier3":24.74,"experienceTier4":36.05},{"tech":"Shell","position":9,"shareValue":0.25,"experienceTier1":14.29,"experienceTier2":21.01,"experienceTier3":25.63,"experienceTier4":39.08},{"tech":"Perl","position":10,"shareValue":0.21,"experienceTier1":9.05,"experienceTier2":11.43,"experienceTier3":24.76,"experienceTier4":54.76}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/charts/TalentByTechInfra.tsx







var TalentByTechInfra = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentByTech_styled_StyledTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.order")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.technology")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.talent-share")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.years-experience")
                }),
                talent_by_technology_infra_sistemas_namespaceObject.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.position
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.tech
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "99%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            margin: {
                                                left: 18
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        25
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "shareValue",
                                                    fill: "#9dcac2",
                                                    barSize: 8,
                                                    radius: 12,
                                                    isAnimationActive: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function(shareValue) {
                                                            return "".concat(shareValue, "%");
                                                        },
                                                        position: "right"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "100%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        100
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier1",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#DEEBF7",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "0-2";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier2",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#6BAED6",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "2-5";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier3",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#2171B5",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "5-10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier4",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#08306B",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "+10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var charts_TalentByTechInfra = (TalentByTechInfra);

;// CONCATENATED MODULE: ./data/mantechcar24/talent-by-technology-mobile.json
var talent_by_technology_mobile_namespaceObject = JSON.parse('[{"tech":"React Native","position":1,"shareValue":3.8,"experienceTier1":27.09,"experienceTier2":34.57,"experienceTier3":27.34,"experienceTier4":11.01},{"tech":"Kotlin","position":2,"shareValue":3.1,"experienceTier1":23.97,"experienceTier2":26.25,"experienceTier3":29.73,"experienceTier4":20.05},{"tech":"Swift","position":3,"shareValue":1.88,"experienceTier1":16.71,"experienceTier2":25.77,"experienceTier3":34.61,"experienceTier4":22.91},{"tech":"Flutter","position":4,"shareValue":1.75,"experienceTier1":27.16,"experienceTier2":33.57,"experienceTier3":24.7,"experienceTier4":14.57},{"tech":"Ionic","position":5,"shareValue":1.22,"experienceTier1":16.39,"experienceTier2":34.17,"experienceTier3":29.59,"experienceTier4":19.84},{"tech":"Xamarin","position":6,"shareValue":0.35,"experienceTier1":14.37,"experienceTier2":25.45,"experienceTier3":26.35,"experienceTier4":33.83}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/charts/TalentByTechMobile.tsx







var TalentByTechMobile = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentByTech_styled_StyledTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.order")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.technology")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.talent-share")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar24.talent.talent-per-tech.years-experience")
                }),
                talent_by_technology_mobile_namespaceObject.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.position
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.tech
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "99%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            margin: {
                                                left: 18
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        25
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "shareValue",
                                                    fill: "#9dcac2",
                                                    barSize: 8,
                                                    radius: 12,
                                                    isAnimationActive: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function(shareValue) {
                                                            return "".concat(shareValue, "%");
                                                        },
                                                        position: "right"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "100%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        100
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier1",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#DEEBF7",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "0-2";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier2",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#6BAED6",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "2-5";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier3",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#2171B5",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "5-10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier4",
                                                    stackId: "a",
                                                    barSize: 8,
                                                    radius: 5,
                                                    fill: "#08306B",
                                                    isAnimationActive: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "+10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var charts_TalentByTechMobile = (TalentByTechMobile);

;// CONCATENATED MODULE: ./data/mantechcar24/experience-by-tech-framework.json
var experience_by_tech_framework_namespaceObject = JSON.parse('[{"tech":"Express","tier1":45.428751473730514,"tier2":29.252224910144733,"tier3":16.309715365055737,"tier4":9.009308251069024},{"tech":"Bootstrap","tier1":41.66463026165764,"tier2":27.912574677549255,"tier3":16.566208498750015,"tier4":13.856586562043091},{"tech":"React","tier1":37.05646966270581,"tier2":29.96964917812203,"tier3":21.816311827641854,"tier4":11.157569331530311},{"tech":"Spring Boot","tier1":26.293029571657343,"tier2":27.61706633630191,"tier3":25.861793177279047,"tier4":20.228110914761693},{"tech":"Laravel","tier1":24.13701133074999,"tier2":28.51480109873939,"tier3":29.543643007799087,"tier4":17.80454456271153},{"tech":"Angular2+","tier1":24.09999977022362,"tier2":30.114668694503713,"tier3":28.993762054945822,"tier4":16.79156948032685},{"tech":"Vue","tier1":21.337510745974626,"tier2":32.88448939458523,"tier3":30.15029024738751,"tier4":15.627709612052637},{"tech":"Spring","tier1":19.656249136879623,"tier2":25.58471953493984,"tier3":28.216600693985125,"tier4":26.542430634195412},{"tech":".NET","tier1":17.427514512860775,"tier2":24.254953814124164,"tier3":28.540757811212615,"tier4":29.776773861802447},{"tech":"jQuery","tier1":15.092186916644657,"tier2":23.220526386905625,"tier3":29.702459055369822,"tier4":31.984827641079892}]');
;// CONCATENATED MODULE: ./data/mantechcar24/experience-by-tech-language.json
var experience_by_tech_language_namespaceObject = JSON.parse('[{"tech":"CSS","tier1":43.13216804791779,"tier2":27.071545802456427,"tier3":18.527765298652675,"tier4":11.26852085097311},{"tech":"HTML","tier1":42.94952743404767,"tier2":26.91996510527705,"tier3":18.687306579087057,"tier4":11.443200881588226},{"tech":"JavaScript","tier1":34.6110136001642,"tier2":28.321123061483487,"tier3":22.23895474491381,"tier4":14.828908593438502},{"tech":"Python","tier1":32.81064625825255,"tier2":29.619767214520056,"tier3":21.40441027683188,"tier4":16.16517625039552},{"tech":"Java","tier1":30.194006400070652,"tier2":25.70300421342878,"tier3":23.40235600740092,"tier4":20.70063337909965},{"tech":"C++","tier1":29.872023959162554,"tier2":26.50034863282704,"tier3":22.447277609387818,"tier4":21.180349798622583},{"tech":"SQL","tier1":27.182735427497033,"tier2":30.176378018426746,"tier3":21.698978569233702,"tier4":20.941907984842523},{"tech":"PHP","tier1":25.934782994929535,"tier2":23.125111336392038,"tier3":26.36515918662603,"tier4":24.574946482052397},{"tech":"TypeScript","tier1":25.43707927000947,"tier2":34.0836366040812,"tier3":26.530433820660726,"tier4":13.9488503052486},{"tech":"C#","tier1":24.640285583305783,"tier2":25.72099157297092,"tier3":25.450294489156704,"tier4":24.18842835456659}]');
;// CONCATENATED MODULE: ./data/mantechcar24/experience-by-tech-other.json
var experience_by_tech_other_namespaceObject = JSON.parse('[{"tech":"Github","tier1":41.03758726697257,"tier2":28.58036259647954,"tier3":16.960623223741663,"tier4":13.421426912806224},{"tech":"NodeJS","tier1":32.45388867135219,"tier2":29.734012296723012,"tier3":23.778677513267894,"tier4":14.033421518656906},{"tech":"MongoDB","tier1":32.379452750773034,"tier2":28.147094426148872,"tier3":23.491899512926306,"tier4":15.981553310151789},{"tech":"MySQL","tier1":31.885844523726842,"tier2":25.14361186101496,"tier3":24.014451684300354,"tier4":18.95609193095784},{"tech":"Git","tier1":28.895197859301224,"tier2":30.91534795989311,"tier3":22.032814077109713,"tier4":18.156640103695956},{"tech":"PostgreSQL","tier1":23.611821229458464,"tier2":29.742668898044364,"tier3":26.711925108307454,"tier4":19.933584764189714},{"tech":"Linux","tier1":21.7339590257898,"tier2":25.95659858979039,"tier3":26.636486772080154,"tier4":25.672955612339656},{"tech":"Docker","tier1":16.95045976204414,"tier2":30.123696520416445,"tier3":29.476145837069918,"tier4":23.4496978804695},{"tech":"Jira","tier1":14.446013364145173,"tier2":31.481419741585853,"tier3":27.518709912194975,"tier4":26.553856982074002},{"tech":"AWS","tier1":13.536568197498717,"tier2":27.81252714254014,"tier3":31.85461856741637,"tier4":26.796286092544772}]');
;// CONCATENATED MODULE: ./data/mantechcar24/least-wanted-techs-by-framework.json
var least_wanted_techs_by_framework_namespaceObject = JSON.parse('[{"name":".NET","value":16.1247066711,"fill":"#08306B"},{"name":"AngularJS","value":6.9169739636,"fill":"#08306B"},{"name":"React","value":3.8328304839,"fill":"#08519C"},{"name":"Angular2+","value":3.6205162588,"fill":"#08519C"},{"name":"jQuery","value":2.2460610124,"fill":"#4292C6"},{"name":".Net Core","value":1.8773047268,"fill":"#4292C6"},{"name":"Vue","value":1.5755950386,"fill":"#6BAED6"},{"name":"React Native","value":1.095094424,"fill":"#6BAED6"},{"name":"Angular Universal","value":0.9163034976,"fill":"#9ECAE1"},{"name":"ASP.net","value":0.9051290647,"fill":"#9ECAE1"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/charts/LeastWantedTechsByFrameworks.tsx




var LeastWantedTechsByFrameworks = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 400,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: least_wanted_techs_by_framework_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "name",
                            tickLine: false,
                            width: 120
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#ebe8df"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "fill",
                            barSize: 12,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_LeastWantedTechsByFrameworks = (LeastWantedTechsByFrameworks);

;// CONCATENATED MODULE: ./data/mantechcar24/least-wanted-techs-by-language.json
var least_wanted_techs_by_language_namespaceObject = JSON.parse('[{"name":"Java","value":23.991507431,"fill":"#08306B"},{"name":"PHP","value":20.069281484,"fill":"#08306B"},{"name":"C++","value":6.0230193318,"fill":"#08519C"},{"name":"Python","value":5.6207397475,"fill":"#08519C"},{"name":"C#","value":5.0731925355,"fill":"#4292C6"},{"name":"JavaScript","value":4.5144708906,"fill":"#4292C6"},{"name":"C","value":4.3356799642,"fill":"#6BAED6"},{"name":"Cobol","value":4.3021566655,"fill":"#6BAED6"},{"name":"CSS","value":2.9723991507,"fill":"#9ECAE1"},{"name":"HTML","value":2.1566655492,"fill":"#9ECAE1"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/charts/LeastWantedTechsByLanguage.tsx




var LeastWantedTechsByLanguage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 400,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: least_wanted_techs_by_language_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "name",
                            tickLine: false,
                            width: 120
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#ebe8df"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "fill",
                            barSize: 12,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_LeastWantedTechsByLanguage = (LeastWantedTechsByLanguage);

;// CONCATENATED MODULE: ./data/mantechcar24/least-wanted-techs-by-other.json
var least_wanted_techs_by_other_namespaceObject = JSON.parse('[{"name":"WordPress","value":3.4975974969,"fill":"#08306B"},{"name":"Windows","value":2.2237121466,"fill":"#08306B"},{"name":"SAP","value":1.1286177227,"fill":"#08519C"},{"name":"NodeJS","value":0.9945245279,"fill":"#08519C"},{"name":"Android","value":0.9163034976,"fill":"#4292C6"},{"name":"Autodesk 3D Studio Max","value":0.8269080344,"fill":"#4292C6"},{"name":"Azure","value":0.6704659739,"fill":"#6BAED6"},{"name":"Oracle","value":0.6704659739,"fill":"#6BAED6"},{"name":"JSP","value":0.6257682423,"fill":"#9ECAE1"},{"name":"MySQL","value":0.6257682423,"fill":"#9ECAE1"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/charts/LeastWantedTechsByOther.tsx




var LeastWantedTechsByOther = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 400,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: least_wanted_techs_by_other_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "name",
                            tickLine: false,
                            width: 120
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#ebe8df"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "fill",
                            barSize: 12,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_LeastWantedTechsByOther = (LeastWantedTechsByOther);

;// CONCATENATED MODULE: ./data/mantechcar24/most-used-techs-by-framework.json
var most_used_techs_by_framework_namespaceObject = JSON.parse('[{"name":"React","value":11.7844254698,"fill":"#08306B"},{"name":"Angular2+","value":4.9742659384,"fill":"#08306B"},{"name":"Bootstrap","value":4.1963282128,"fill":"#08519C"},{"name":"Spring Boot","value":3.8344737828,"fill":"#08519C"},{"name":"Vue","value":3.7427777011,"fill":"#4292C6"},{"name":"Express","value":3.517974404,"fill":"#4292C6"},{"name":".NET","value":3.1995030664,"fill":"#6BAED6"},{"name":"jQuery","value":3.1709096646,"fill":"#6BAED6"},{"name":"Spring","value":2.9401904912,"fill":"#9ECAE1"},{"name":"Laravel","value":2.7508824515,"fill":"#9ECAE1"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/charts/MostUsedTechsByFrameworks.tsx




var MostUsedTechsByFrameworks = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 400,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: most_used_techs_by_framework_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "name",
                            tickLine: false,
                            width: 120
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#ebe8df"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "fill",
                            barSize: 12,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MostUsedTechsByFrameworks = (MostUsedTechsByFrameworks);

;// CONCATENATED MODULE: ./data/mantechcar24/most-used-techs-by-language.json
var most_used_techs_by_language_namespaceObject = JSON.parse('[{"name":"JavaScript","value":20.651337974,"fill":"#08306B"},{"name":"HTML","value":15.5626984283,"fill":"#08306B"},{"name":"CSS","value":14.8833586401,"fill":"#08519C"},{"name":"Java","value":13.3304411272,"fill":"#08519C"},{"name":"Python","value":12.6313817515,"fill":"#4292C6"},{"name":"SQL","value":10.1072745558,"fill":"#4292C6"},{"name":"PHP","value":8.2122222003,"fill":"#6BAED6"},{"name":"TypeScript","value":7.5496440614,"fill":"#6BAED6"},{"name":"C#","value":4.7612943937,"fill":"#9ECAE1"},{"name":"C++","value":3.0072370886,"fill":"#9ECAE1"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/charts/MostUsedTechsByLanguage.tsx




var MostUsedTechsByLanguage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 400,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: most_used_techs_by_language_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "name",
                            tickLine: false,
                            width: 120
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#ebe8df"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "fill",
                            barSize: 12,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MostUsedTechsByLanguage = (MostUsedTechsByLanguage);

;// CONCATENATED MODULE: ./data/mantechcar24/most-used-techs-by-other.json
var most_used_techs_by_other_namespaceObject = JSON.parse('[{"name":"MySQL","value":11.5044073278,"fill":"#08306B"},{"name":"Git","value":10.7412592929,"fill":"#08306B"},{"name":"NodeJS","value":9.8814852793,"fill":"#08519C"},{"name":"Docker","value":8.3295537457,"fill":"#08519C"},{"name":"MongoDB","value":7.2804716925,"fill":"#4292C6"},{"name":"PostgreSQL","value":6.1022263414,"fill":"#4292C6"},{"name":"AWS","value":5.7295261383,"fill":"#6BAED6"},{"name":"Github","value":5.4189426357,"fill":"#6BAED6"},{"name":"Linux","value":5.393307172,"fill":"#9ECAE1"},{"name":"Jira","value":5.1882234624,"fill":"#9ECAE1"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/charts/MostUsedTechsByOther.tsx




var MostUsedTechsByOther = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 400,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: most_used_techs_by_other_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            domain: [
                                0,
                                6
                            ],
                            tickFormatter: function(tick) {
                                return "".concat(tick.toFixed(1), "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "name",
                            tickLine: false,
                            width: 120
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#ebe8df"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "fill",
                            barSize: 12,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MostUsedTechsByOther = (MostUsedTechsByOther);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/ExperienceByRole.styled.tsx

function ExperienceByRole_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-x: auto;\n"
    ]);
    ExperienceByRole_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ExperienceByRole_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-collapse: collapse;\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  &.experience-table {\n    max-width: ",
        ";\n  }\n\n  thead th {\n    border-bottom: 1px solid ",
        ";\n    font-size: ",
        ";\n    line-height: 1.14;\n    padding-bottom: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  tbody th {\n    text-align: right;\n    font-weight: ",
        ";\n    padding-right: ",
        ";\n    white-space: nowrap;\n  }\n\n  tbody tr {\n    transition: 0.3s;\n  }\n\n  tr:first-of-type th,\n  tr:first-of-type td {\n    padding-top: ",
        ";\n  }\n\n  &:hover tbody tr {\n    opacity: 0.5;\n  }\n\n  tbody tr:hover {\n    opacity: 1;\n  }\n"
    ]);
    ExperienceByRole_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ExperienceByRole_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  min-width: 4.5rem;\n  height: 2.25rem;\n  border-radius: ",
        ";\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  &.cell-color-1 {\n    background-color: ",
        ";\n  }\n  &.cell-color-2 {\n    background-color: ",
        ";\n  }\n  &.cell-color-3 {\n    background-color: ",
        ";\n  }\n  &.cell-color-4 {\n    background-color: ",
        ";\n  }\n  &.cell-color-5 {\n    background-color: ",
        ";\n  }\n  &.cell-color-6 {\n    background-color: ",
        ";\n  }\n  &.cell-color-7 {\n    background-color: ",
        ";\n  }\n  &.cell-color-8 {\n    background-color: ",
        ";\n  }\n"
    ]);
    ExperienceByRole_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ExperienceByRole_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8db43d52-0"
})(ExperienceByRole_styled_templateObject());
var ExperienceByRole_styled_StyledTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-8db43d52-1"
})(ExperienceByRole_styled_templateObject1(), (0,theme/* spacing */.W0)("sm"), (0,theme/* container */.nC)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"));
var ExperienceByRole_styled_StyledValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8db43d52-2"
})(ExperienceByRole_styled_templateObject2(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* radius */.q0)("sm"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("seq_blue_02"), (0,theme/* color */.$_)("seq_blue_03"), (0,theme/* color */.$_)("seq_blue_04"), (0,theme/* color */.$_)("seq_blue_05"), (0,theme/* color */.$_)("seq_blue_06"), (0,theme/* color */.$_)("seq_blue_07"), (0,theme/* color */.$_)("seq_blue_08"), (0,theme/* color */.$_)("seq_blue_09"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/ExperienceByRole.tsx



var ExperienceByRole = function(param) {
    var data = param.data;
    var getClassColor = function(val) {
        if (val === 0) {
            return "cell-color-1";
        }
        if (val > 0 && val <= 5) {
            return "cell-color-2";
        }
        if (val > 5 && val <= 9) {
            return "cell-color-3";
        }
        if (val > 9 && val <= 14) {
            return "cell-color-4";
        }
        if (val > 14 && val <= 19) {
            return "cell-color-5";
        }
        if (val > 19 && val <= 24) {
            return "cell-color-6";
        }
        if (val > 24 && val <= 29) {
            return "cell-color-7";
        }
        if (val > 29) {
            return "cell-color-8";
        } else {
            return "cell-color-1";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExperienceByRole_styled_StyledContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExperienceByRole_styled_StyledTable, {
            className: "experience-table",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "<2y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "2-5y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "5-10y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: ">10y"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: data.map(function(data, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: data.tech
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExperienceByRole_styled_StyledValue, {
                                        className: getClassColor(data.tier1),
                                        children: [
                                            data.tier1.toFixed(1),
                                            "%"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExperienceByRole_styled_StyledValue, {
                                        className: getClassColor(data.tier2),
                                        children: [
                                            data.tier2.toFixed(1),
                                            "%"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExperienceByRole_styled_StyledValue, {
                                        className: getClassColor(data.tier3),
                                        children: [
                                            data.tier3.toFixed(1),
                                            "%"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExperienceByRole_styled_StyledValue, {
                                        className: getClassColor(data.tier4),
                                        children: [
                                            data.tier4.toFixed(1),
                                            "%"
                                        ]
                                    })
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var talent_ExperienceByRole = (ExperienceByRole);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/Talent.constants.tsx











var TALENTBYTECHOPTIONS = function(t) {
    return [
        {
            label: t("mantechcar24.talent.talent-per-tech.front"),
            value: "front"
        },
        {
            label: t("mantechcar24.talent.talent-per-tech.back"),
            value: "back"
        },
        {
            label: t("mantechcar24.talent.talent-per-tech.mobile"),
            value: "mobile"
        },
        {
            label: t("mantechcar24.talent.talent-per-tech.data"),
            value: "data"
        },
        {
            label: t("mantechcar24.talent.talent-per-tech.infra"),
            value: "infra"
        }
    ];
};
var MOSTUSEDTECHSTABS = function(t) {
    return {
        tabsName: "mostUsedTechs",
        tabs: [
            {
                id: "mostUsedTechsByLang",
                label: t("mantechcar24.talent.most-used-techs.languages"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostUsedTechsByLanguage, {})
            },
            {
                id: "mostUsedTechsByFrameworks",
                label: t("mantechcar24.talent.most-used-techs.frameworks"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostUsedTechsByFrameworks, {})
            },
            {
                id: "mostUsedTechsByOther",
                label: t("mantechcar24.talent.most-used-techs.other-techs"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostUsedTechsByOther, {})
            }
        ]
    };
};
var LEASTWANTEDTECHSTABS = function(t) {
    return {
        tabsName: "leastWantedTechs",
        tabs: [
            {
                id: "leastWantedTechsByLang",
                label: t("mantechcar24.talent.least-wanted-techs.languages"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_LeastWantedTechsByLanguage, {})
            },
            {
                id: "leastWantedTechsByFrameworks",
                label: t("mantechcar24.talent.least-wanted-techs.frameworks"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_LeastWantedTechsByFrameworks, {})
            },
            {
                id: "leastWantedTechsByOther",
                label: t("mantechcar24.talent.least-wanted-techs.other-techs"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_LeastWantedTechsByOther, {})
            }
        ]
    };
};
var EXPERIENCEBYROLETABS = function(t) {
    return {
        tabsName: "experienceByRole",
        tabs: [
            {
                id: "experienceByRoleByLang",
                label: t("mantechcar24.talent.main-techs.languages"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(talent_ExperienceByRole, {
                    data: experience_by_tech_language_namespaceObject
                })
            },
            {
                id: "experienceByRoleByFramework",
                label: t("mantechcar24.talent.main-techs.frameworks"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(talent_ExperienceByRole, {
                    data: experience_by_tech_framework_namespaceObject
                })
            },
            {
                id: "experienceByRoleByOther",
                label: t("mantechcar24.talent.main-techs.other-techs"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(talent_ExperienceByRole, {
                    data: experience_by_tech_other_namespaceObject
                })
            }
        ]
    };
};

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/Talent.styled.tsx

function Talent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " ",
        "::before {\n    background-color: ",
        ";\n  }\n"
    ]);
    Talent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Talent_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: flex-start;\n  min-width: 16rem;\n"
    ]);
    Talent_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var Talent_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-55186e1e-0"
})(Talent_styled_templateObject(), StyledContainer, Typography_styled/* Heading2 */.XJ, (0,theme/* color */.$_)("sun_500"));
var StyledSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-55186e1e-1"
})(Talent_styled_templateObject1());

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/components/talent/Talent.tsx

















var Talent = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    var mostUsedTechTabs = MOSTUSEDTECHSTABS(t);
    var leastWantedTechTabs = LEASTWANTEDTECHSTABS(t);
    var experienceByRoleTabs = EXPERIENCEBYROLETABS(t);
    var talentByTechOptions = TALENTBYTECHOPTIONS(t);
    var ref = (0,react.useState)("front"), currentOption = ref[0], setCurrentOption = ref[1];
    var handleOptionChange = function(param) {
        var value = param.value;
        setCurrentOption(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Talent_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionHero_SectionHero, {
                image: (0,paths/* getPublicPath */.A)("/images/stateSector/2024/talent.png"),
                title: t("mantechcar24.talent.hero.title"),
                desc: t("mantechcar24.talent.hero.desc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(sectionChart_SectionChart, {
                title: t("mantechcar24.talent.talent-per-tech.title"),
                shareId: "talentpertech",
                emailSubject: t("mantechcar24.share-modal.talent-per-tech.email-subject"),
                emailMessage: t("mantechcar24.share-modal.talent-per-tech.email-text"),
                shareMessage: t("mantechcar24.share-modal.talent-per-tech.text"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelect/* default */.Z, {
                            options: talentByTechOptions,
                            defaultValue: talentByTechOptions[0],
                            id: "talentByTechSelect",
                            onChange: handleOptionChange
                        })
                    }),
                    currentOption === "front" && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_TalentByTechFrontend, {}),
                    currentOption === "back" && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_TalentByTechBackend, {}),
                    currentOption === "mobile" && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_TalentByTechMobile, {}),
                    currentOption === "data" && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_TalentByTechData, {}),
                    currentOption === "infra" && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_TalentByTechInfra, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar24.talent.roles-distribution.title"),
                desc: t("mantechcar24.talent.roles-distribution.desc"),
                descExtra: t("mantechcar24.talent.roles-distribution.descExtra"),
                shareId: "rolesdistribution",
                emailSubject: t("mantechcar24.share-modal.roles-distribution.email-subject"),
                emailMessage: t("mantechcar24.share-modal.roles-distribution.email-text"),
                shareMessage: t("mantechcar24.share-modal.roles-distribution.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_RolesDistribution, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar24.talent.most-used-techs.title"),
                desc: t("mantechcar24.talent.most-used-techs.desc"),
                descExtra: t("mantechcar24.talent.most-used-techs.descExtra"),
                shareId: "mostusedtechs",
                emailSubject: t("mantechcar24.share-modal.most-used-techs.email-subject"),
                emailMessage: t("mantechcar24.share-modal.most-used-techs.email-text"),
                shareMessage: t("mantechcar24.share-modal.most-used-techs.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(switcher_Switcher, {
                    tabsName: mostUsedTechTabs.tabsName,
                    tabs: mostUsedTechTabs.tabs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar24.talent.least-wanted-techs.title"),
                desc: t("mantechcar24.talent.least-wanted-techs.desc"),
                descExtra: t("mantechcar24.talent.least-wanted-techs.descExtra"),
                shareId: "leastwantedtechs",
                emailSubject: t("mantechcar24.share-modal.least-wanted-techs.email-subject"),
                emailMessage: t("mantechcar24.share-modal.least-wanted-techs.email-text"),
                shareMessage: t("mantechcar24.share-modal.least-wanted-techs.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(switcher_Switcher, {
                    tabsName: leastWantedTechTabs.tabsName,
                    tabs: leastWantedTechTabs.tabs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar24.talent.main-techs.title"),
                desc: t("mantechcar24.talent.main-techs.desc"),
                descExtra: t("mantechcar24.talent.main-techs.descExtra"),
                shareId: "experiencebyrole",
                emailSubject: t("mantechcar24.share-modal.main-techs.email-subject"),
                emailMessage: t("mantechcar24.share-modal.main-techs.email-text"),
                shareMessage: t("mantechcar24.share-modal.main-techs.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(switcher_Switcher, {
                    tabsName: experienceByRoleTabs.tabsName,
                    tabs: experienceByRoleTabs.tabs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar24.talent.competences.title"),
                desc: t("mantechcar24.talent.competences.desc"),
                descExtra: t("mantechcar24.talent.competences.descExtra"),
                shareId: "competences",
                emailSubject: t("mantechcar24.share-modal.competences.email-subject"),
                emailMessage: t("mantechcar24.share-modal.competences.email-text"),
                shareMessage: t("mantechcar24.share-modal.competences.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_SoftSkillsCommunityVsOffered, {})
            })
        ]
    });
};
/* harmony default export */ var talent_Talent = (Talent);

// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 4 modules
var polished_esm = __webpack_require__(28870);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/ManTechCar.styled.ts

function ManTechCar_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  --headingColor: #312784;\n"
    ]);
    ManTechCar_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ManTechCar_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: linear-gradient(\n      ",
        ",\n      ",
        "\n    ),\n    url('",
        "');\n  background-size: cover;\n  background-position: top center;\n  padding: ",
        " ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n\n  @media (min-width: ",
        ") {\n    background-image: linear-gradient(\n        ",
        ",\n        ",
        "\n      ),\n      url('",
        "');\n  }\n"
    ]);
    ManTechCar_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ManTechCar_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    ManTechCar_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledPage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aa95628c-0"
})(ManTechCar_styled_templateObject());
var StyledFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aa95628c-1"
})(ManTechCar_styled_templateObject1(), (0,polished_esm/* rgba */.m4)("#1F1D26", 0.75), (0,polished_esm/* rgba */.m4)("#1F1D26", 0.75), (0,paths/* getPublicPath */.A)("/images/stateSector/2023/hero-bg-sm.webp"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* screen */.sp)("md"), (0,polished_esm/* rgba */.m4)("#1F1D26", 0.75), (0,polished_esm/* rgba */.m4)("#1F1D26", 0.75), (0,paths/* getPublicPath */.A)("/images/stateSector/2023/hero-bg.webp"));
var StyledFooterActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aa95628c-2"
})(ManTechCar_styled_templateObject2(), (0,theme/* spacing */.W0)("sm"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar24/ManTechCar.tsx










var ManTechCarComponent = function(param) {
    var manfreditesCount = param.manfreditesCount;
    // Render.
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.ZP, {
        hasScrollTop: true,
        pageVariant: "light",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPage, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(intro_Intro, {
                    manfreditesCount: manfreditesCount
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(talent_Talent, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_Benefits, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(companies_Companies, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(gender_Gender, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(insights_Insights, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(methodology_Methodology, {})
            ]
        })
    });
};
/* harmony default export */ var ManTechCar = (ManTechCarComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./pages/developer-career-report-2024.tsx








var ManTechCar24Page = function(param) {
    var baseUrl = param.baseUrl, manfreditesCount = param.manfreditesCount;
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2024").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("mantechcar24.page_title"),
                url: app_urls/* APP_URLS.mantechcar24 */.uu.mantechcar24,
                desc: t("mantechcar24.page_description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_developer_career_report_2024.png")),
                indexable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "devCareerReportLD",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n  "@context": "https://schema.org",\n  "@type": "Report",\n  "name": "'.concat(t("mantechcar24.page_title"), '",\n  "url": "https://www.getmanfred.com/developer-career-report",\n  "description": "').concat(t("mantechcar24.page_description"), '",\n  "author": {\n    "@type": "Organization",\n    "name": "Get Manfred",\n    "url": "https://www.getmanfred.com",\n    "logo": {\n      "@type": "ImageObject",\n       "url": "https://media-asgard.s3.eu-west-1.amazonaws.com/manfred-media/logo_manfred_color.svg?v=38732000",\n    }\n  },\n  "publisher": {\n    "@type": "Organization",\n    "name": "Manfred",\n    "url": "https://www.getmanfred.com"\n  },\n  "datePublished": "2024-11-04",\n  "mainEntityOfPage": "https://www.getmanfred.com/developer-career-report",\n  "articleSection": "Carrera de Desarrolladores, Oportunidades en IT, Tendencias del Sector"\n}')
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ManTechCar, {
                manfreditesCount: manfreditesCount
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var developer_career_report_2024 = (ManTechCar24Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,8746,9001,2077,3004,1601,6658,9161,9092,8157,9774,2888,179], function() { return __webpack_exec__(65169); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);